import MindMap from 'simple-mind-map'
import FileSaver from 'file-saver'
import { getTabColOrData } from '../../api/user'
import { getDate } from '../../api/Select'
import pubWin from '../../views/datamgt/pubwin.vue'
import pubMulti from '../../views/datamgt/pub_easy_multi.vue'
import ProcessDetailPanel from './ProcessDetailPanel.vue'
import sourceDialogMixin from './mixins/sourceDialogMixin'
import nodeAddMixin from './mixins/nodeAddMixin'
import orderProcessMixin from './mixins/orderProcessMixin'
import productModeMixin from './mixins/productModeMixin'

var NODE_CARD_WIDTH = 280
var NODE_CARD_MINE_WIDTH = 320
var ROOT_NODE_CARD_WIDTH = 660
var ROOT_NODE_CARD_MINE_WIDTH = 720

function isSafariMindMapFallbackBrowser() {
  if (typeof navigator === 'undefined') return false
  var userAgent = navigator.userAgent || ''
  var vendor = navigator.vendor || ''
  return /Safari/i.test(userAgent) &&
    /Apple/i.test(vendor) &&
    !/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|OPiOS|Android)/i.test(userAgent)
}

/**
 * 订单流程思维导图主组件：负责订单流程加载、节点渲染、详情侧栏、
 * 进度跟进、附件上传和来源单据入口。
 */
export default {
  name: 'ProcessMindMap',
  mixins: [productModeMixin, sourceDialogMixin, orderProcessMixin, nodeAddMixin],
  components: {
    pubWin: pubWin,
    pubMulti: pubMulti,
    ProcessDetailPanel: ProcessDetailPanel,
    // 应收核销来源单据详情弹窗，按需加载以减小初始包体。
    ArCheckDetailDialog: function () {
      return import('./ArCheckDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 采购申请来源单据详情弹窗。
    PoRequestDetailDialog: function () {
      return import('./PoRequestDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 订单评审来源单据详情弹窗。
    OrderAuditDetailDialog: function () {
      return import('./OrderAuditDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 领料出库来源单据详情弹窗。
    PcPickDetailDialog: function () {
      return import('./PcPickDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 制程巡检来源单据详情弹窗。
    QcPrdDetailDialog: function () {
      return import('./QcPrdDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 成品检验报告来源单据详情弹窗。
    PrdChkRptDetailDialog: function () {
      return import('./PrdChkRptDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 销售收款来源单据详情弹窗。
    SaleReceiveDetailDialog: function () {
      return import('./SaleReceiveDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 销售出货来源单据详情弹窗。
    SaleOutDetailDialog: function () {
      return import('./SaleOutDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 成品入库来源单据详情弹窗。
    PrdInDetailDialog: function () {
      return import('./PrdInDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 生产出库来源单据详情弹窗。
    PrdOutDetailDialog: function () {
      return import('./PrdOutDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 来料质检来源单据详情弹窗。
    IncomingQaDetailDialog: function () {
      return import('./IncomingQaDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 质检入库来源单据详情弹窗。
    IncomingStkInDetailDialog: function () {
      return import('./IncomingStkInDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // 物料计划来源单据详情弹窗。
    MaterialPlanDetailDialog: function () {
      return import('./MaterialPlanDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    },
    // BOM 来源单据详情弹窗。
    TreeBomDetailDialog: function () {
      return import('./TreeBomDetailDialog.vue').then(function (module) {
        return module.default || module
      })
    }
  },
  props: {
    // 当前订单行，流程图以该行的订单主键加载订单流程数据。
    orderRow: {
      type: Object,
      required: true
    },
    // 只读模式开关，开启后禁止跟进、进度、节点增删等写操作。
    readonly: {
      type: Boolean,
      default: false
    },
    // 外部控制组件显示状态，抽屉模式下作为 v-model 使用。
    visible: {
      type: Boolean,
      default: false
    },
    // 是否以右侧抽屉形态展示流程图。
    drawer: {
      type: Boolean,
      default: false
    },
    // 外部传入的抽屉标题，为空时使用订单标题。
    drawerTitle: {
      type: String,
      default: ''
    },
    // 是否让流程图容器占满可用高度。
    fullHeight: {
      type: Boolean,
      default: false
    },
    // 是否显示订单流程节点新增、删除能力。
    enableNodeAdd: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      // 思维导图实例、当前选中节点和渲染请求令牌。
      mindMap: null,
      selectedNode: null,
      selectedNodeKey: '',
      fishboneDetailRequestToken: 0,
      flowData: {},
      // 订单流程骨架、维护记录和详情侧栏展示数据。
      internalWorkDetails: [],
      orderProcessRows: [],
      fishboneDetailVisible: false,
      fishboneDetailNode: null,
      fishboneProjectRow: {},
      fishboneTaskRow: {},
      fishboneRootAttachments: [],
      fishboneTaskAttachments: [],
      fishboneLogList: [],
      // 当前用户对订单流程维护表单的操作权限。
      addBool: false,
      editBool: false,
      delBool: false,
      // 状态字典、跟进必填规则和跟进弹窗数据。
      stfgArr: [],
      logNull: [],
      logValidate: {},
      logWin: false,
      logRow: {},
      phoData: [],
      delLogImg: [],
      // 节点进度/负责人维护弹窗状态。
      pctWin: false,
      pctMode: '',
      vPct: 0,
      tStfg: '',
      tRmk: '',
      processOwner: '',
      processFindDttm: '',
      processOwnerEmpId: '',
      empSelectWin: false,
      // 负责人选择弹窗的列配置和过滤条件。
      empSelectColumns: [],
      empSelectTable: '',
      empSelectKey2: '',
      empSelectValue2: '',
      empSelectRandom: 0,
      // 订单流程节点新增、删除弹窗和保存状态。
      nodeAddWin: false,
      nodeAddParent: null,
      nodeAddMode: '',
      nodeAddSaving: false,
      nodeDeleteSaving: false,
      nodeAddForm: {},
      nodeAddColumns: [],
      nodeAddValidate: {},
      nodeAddRequiredFields: [],
      nodeAddComboArr: {},
      nodeAddWktyArr: [],
      nodeAddSelectWin: false,
      nodeAddMultiWin: false,
      // 节点新增弹窗内通用选择器的当前字段和查询条件。
      nodeAddSelectKey: '',
      nodeAddSelectColumns: [],
      nodeAddSelectTable: '',
      nodeAddSelectKey2: '',
      nodeAddSelectValue2: '',
      nodeAddSelectCond: '',
      nodeAddSelectRandom: 0,
      nodeAddEmpColumns: [],
      nodeAddFormColumns: [],
      nodeAddItemColumns: [],
      nodeAddPoColumns: [],
      nodeAddOrdColumns: [],
      nodeAddNewColumns: [],
      // 通用提示、加载和上传进度状态。
      promptWin: false,
      prompt: '',
      loadWin: false,
      videoFlag: false,
      videoUploadPercent: 0,
      uploadData: {},
      // 来源单据弹窗的当前节点和各类单据可见状态。
      sourceDialogNode: null,
      arCheckDialogVisible: false,
      poDialogVisible: false,
      orderAuditDialogVisible: false,
      pcPickDialogVisible: false,
      qcPrdDialogVisible: false,
      prdChkRptDialogVisible: false,
      saleReceiveDialogVisible: false,
      saleOutDialogVisible: false,
      prdInDialogVisible: false,
      prdOutDialogVisible: false,
      incomingQaDialogVisible: false,
      incomingStkInDialogVisible: false,
      materialPlanDialogVisible: false,
      treeBomDialogVisible: false,
      // 当前用户可查看的来源表单权限，按 v_sys_user_priv.FRMIDSEQ 建索引。
      sourceFormPermissionMap: {},
      sourceFormPermissionLoaded: false,
      // 详情侧栏折叠、主弹层开启和视图自适应计时器。
      detailPanelCollapsed: false,
      detailPanelLockedCollapsed: false,
      mainDialogOpened: false,
      viewFitTimers: [],
      viewFitHandler: null,
      viewFitMindMap: null,
      initMindMapTimer: null,
      resizeObserver: null,
      resizeTimer: null,
      lastContainerSize: { width: 0, height: 0 },
      mindMapRenderToken: 0,
      fishboneLoadRequestId: 0,
      nodeContentRenderSeq: 0,
      nodeOverlayRenderTimer: null,
      useHtmlNodeOverlay: isSafariMindMapFallbackBrowser(),
      fishboneSetupLoaded: false,
      // 来源单据探测状态缓存，避免重复请求并防止旧请求回写。
      sourceStatusMap: {},
      sourceProbeToken: 0,
      sourceProbeInFlight: {}
    }
  },
  computed: {
    /**
     * 主弹层可见状态的双向代理，用于向父组件同步 visible。
     */
    innerVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    /**
     * 汇总手动折叠和锁定折叠状态，供布局和按钮共用。
     */
    isDetailPanelCollapsed: function () {
      return this.detailPanelCollapsed || this.detailPanelLockedCollapsed
    },
    /**
     * 根据展示模式和详情侧栏状态生成根容器 class。
     */
    rootClass: function () {
      return {
        'fishbone-mind-map--full': this.fullHeight || this.drawer,
        'fishbone-mind-map--with-detail': this.fishboneDetailVisible && this.currentDetailNode && !this.isDetailPanelCollapsed,
        'fishbone-mind-map--detail-collapsed': this.fishboneDetailVisible && this.currentDetailNode && this.isDetailPanelCollapsed,
        'fishbone-mind-map--html-node-overlay': this.useHtmlNodeOverlay
      }
    },
    /**
     * 统一封装只读状态，便于 mixin 中复用。
     */
    isReadonlyMode: function () {
      return this.readonly
    },
    /**
     * 当前详情侧栏绑定的节点。
     */
    currentDetailNode: function () {
      return this.fishboneDetailNode || null
    },
    /**
     * 当前订单根节点数据，保留旧面板命名兼容。
     */
    currentProjectRow: function () {
      return this.fishboneProjectRow || {}
    },
    /**
     * 当前选中任务节点的订单维护数据。
     */
    currentTaskRow: function () {
      return this.fishboneTaskRow || {}
    },
    /**
     * 根节点汇总附件列表。
     */
    currentRootAttachments: function () {
      return this.fishboneRootAttachments || []
    },
    /**
     * 当前任务节点附件列表。
     */
    currentTaskAttachments: function () {
      return this.fishboneTaskAttachments || []
    },
    /**
     * 当前任务跟进日志，仅保留有实际备注的记录。
     */
    currentLogList: function () {
      return (this.fishboneLogList || []).filter(function (item) {
        return this.hasLogRemark(item && item.LOGRMK)
      }.bind(this))
    },
    /**
     * 详情面板按钮权限和当前用户信息。
     */
    currentActionState: function () {
      return {
        addBool: this.addBool,
        editBool: this.editBool,
        delBool: this.delBool,
        // 任务维护由管理员、订单负责人或节点负责人决定，不能被表单新增权限单独阻断。
        settingDisabled: !this.canMaintainOrderProcessRow(this.currentTaskRow || {}),
        sourceReadonly: this.isCurrentRefDocumentDisabled(),
        vAdmin: this.vAdmin,
        vUsernm: this.vUsernm
      }
    },
    /**
     * 附件上传接口地址，附带当前登录凭据。
     */
    uploadUrl: function () {
      return   '/xuper_oss/ftpUpload_nocheck'
    },
    /**
     * 当前登录账号。
     */
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },

    /**
     * 当前登录用户名称。
     */
    vUsernm: function () {
      return this.$cookies.get('v_usernm')
    },
    /**
     * 当前用户是否为管理员。
     */
    vAdmin: function () {
      return this.$cookies.get('v_admin')
    },
    /**
     * 当前订单所属公司，优先取订单行，其次取登录上下文。
     */
    vCorpid: function () {
      var row = this.effectiveOrderRow || {}
      return row.CORPID || row.corpid || this.$cookies.get('v_corpid')
    },
    /**
     * 抽屉标题，外部标题为空时按订单生成标题。
     */
    drawerTitleText: function () {
      if (this.drawerTitle) return this.drawerTitle
      return this.buildOrderTitle(
        this.currentProjectRow && Object.keys(this.currentProjectRow).length
          ? this.currentProjectRow
          : this.effectiveOrderRow
      )
    },
    /**
     * 详情侧栏标题，根节点显示订单标题，任务节点显示工序名称。
     */
    detailTitle: function () {
      if (!this.currentDetailNode) return '任务详情'
      if (this.currentDetailNode.type === 'root') return displayRootTitle(this.currentProjectRow)
      var raw = this.currentDetailNode.raw || {}
      return this.displayText(this.currentTaskRow.WKNM || raw.WKNM)
    },
    /**
     * 详情侧栏状态展示信息，和节点卡片保持同一套五态颜色。
     */
    currentDetailStatusInfo: function () {
      if (!this.currentDetailNode) return this.getStatusInfo('')
      if (this.currentDetailNode.type === 'root') {
        return this.getStatusInfo(this.currentProjectRow.DISPLAY_STFG || this.currentProjectRow.STFG)
      }
      var raw = this.currentDetailNode.raw || {}
      var row = Object.assign({}, raw, this.currentTaskRow)
      return this.getStatusInfo(this.getNodeStatus(row))
    }
  },
  watch: {
    orderRow: {
      /**
       * 订单行变化时重新加载流程图，主弹层关闭状态下延后到打开时加载。
       */
      handler: function () {
        if (!this.drawer || this.innerVisible) this.openFishbone()
      },
      deep: true
    },
    /**
     * 控制显示/关闭时的加载和状态清理。
     */
    visible: function (value) {
      if (value) {
        if (this.drawer) this.mainDialogOpened = false
        this.openFishbone()
        this.ensureMainDialogOpened()
      } else {
        this.resetFishboneState()
      }
    }
  },
  /**
   * 非弹层场景或初始可见弹层场景下立即加载流程图。
   */
  mounted: function () {
    window.addEventListener('resize', this.scheduleResize)
    if (!this.drawer || this.innerVisible) {
      this.openFishbone()
      this.ensureMainDialogOpened()
    }
  },
  /**
   * 组件销毁前释放思维导图实例和内部计时器。
   */
  beforeDestroy: function () {
    window.removeEventListener('resize', this.scheduleResize)
    this.stopContainerResizeObserver()
    this.fishboneLoadRequestId += 1
    this.resetProductModeState()
    this.destroyMindMap()
  },
  methods: {
    /**
     * 深拷贝普通对象或数组，用于隔离弹窗编辑态。
     */
    cloneValue: function (value) {
      return JSON.parse(JSON.stringify(value || (Array.isArray(value) ? [] : {})))
    },
    /**
     * 拼接项目内鉴权接口地址。
     */
    authUrl: function (path) {
      return  path + ''
    },
    /**
     * 打开统一提示弹窗。
     */
    showPrompt: function (message) {
      this.prompt = message || (this.$LANG('1442', '提示') + '：' + this.$LANG('', '加载失败'))
      this.promptWin = true
    },
    /**
     * 清空来源单据探测缓存，并使旧探测请求失效。
     */
    resetSourceStatusProbeState: function () {
      this.sourceProbeToken += 1
      this.sourceStatusMap = {}
      this.sourceProbeInFlight = {}
    },
    /**
     * 判断保存接口返回是否表示成功。
     */
    isOkSaveResponse: function (data) {
      data = data || {}
      if (String(data.code || '') === '200') return true
      if (String(data.result || '').toUpperCase() === 'OK') return true
      return !!(data.idseq || data.IDSEQ || data.lstseq || data.LSTSEQ)
    },
    /**
     * 从保存接口返回中提取可展示的错误信息。
     */
    getSaveResponseError: function (data) {
      data = data || {}
      return data.result || data.message || data.msg || this.$LANG('1442', '提示')
    },
    /**
     * 将接口返回规范成数组，避免调用方重复判断。
     */
    normalizeRows: function (rows) {
      return Array.isArray(rows) ? rows : []
    },
    /**
     * 调用 getBaseData 字典接口并返回数组结果。
     */
    loadBaseRows: function (payload) {
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/getBaseData'),
        data: payload
      }).then(function (res) {
        return this.normalizeRows(res && res.result)
      }.bind(this))
    },
    /**
     * 调用 getTableRecMany 表查询接口并返回数组结果。
     */
    loadTableRows: function (table, key, value, key2, value2, key3, value3, cond) {
      return getTabColOrData(
         'xuper_auth/getTableRecMany',

        table,
        key || '',
        value || '',
        key2 || '',
        value2 || '',
        key3 || '',
        value3 || '',
        cond || ''
      ).then(function (res) {
        return this.normalizeRows(res && res.result)
      }.bind(this))
    },
    /**
     * 生成节点在 DOM、缓存和选中状态中的稳定 key。
     */
    getNodeSelectionKey: function (data) {
      data = data || {}
      return String(data.id || data.CODE || data.LSTSEQ || data.IDSEQ || '')
    },
    /**
     * 生成渲染层去重业务 key：订单号 + 节点 IDSEQ。
     */
    getRenderedNodeBusinessKey: function (data) {
      data = data || {}
      var orderRow = this.effectiveOrderRow || {}
      var orderNo = String(
        data.ORDNO || orderRow.REFIDNO || orderRow.refidno || orderRow.ORDNO || orderRow.ordno || ''
      ).trim()
      var nodeIdseq = data.id === 'root' ? 'ORDER_ROOT' : String(data.IDSEQ || '').trim()
      if (!orderNo || !nodeIdseq) return ''
      return orderNo + '::' + nodeIdseq
    },
    /**
     * 固定 custom foreignObject 的测量宽度，避免 Safari 按内容重新撑开节点。
     */
    getNodeCardRenderWidth: function (data) {
      data = data || {}
      var nodeOwner = String(data.EMPNM || data.EMPNM2 || '').trim()
      var isCurrentUserNode = nodeOwner && nodeOwner === this.vUsernm
      if (data.id === 'root') return isCurrentUserNode ? ROOT_NODE_CARD_MINE_WIDTH : ROOT_NODE_CARD_WIDTH
      return isCurrentUserNode ? NODE_CARD_MINE_WIDTH : NODE_CARD_WIDTH
    },
    /**
     * 同步当前选中节点的 DOM 高亮样式。
     */
    updateSelectedNodeStyle: function (nodeData) {
      var roots = this.getNodeCardDomRoots()
      if (!roots.length) return
      var key = this.getNodeSelectionKey(nodeData)
      if (!key && this.selectedNodeKey) key = this.selectedNodeKey
      if (!key) {
        this.selectedNodeKey = ''
        roots.forEach(function (root) {
          Array.prototype.forEach.call(root.querySelectorAll('.node-card--selected'), function (item) {
            item.classList.remove('node-card--selected')
          })
        })
        return
      }
      var selector = '.node-card[data-node-key="' + String(key).replace(/"/g, '\\"') + '"]'
      var card = null
      if (this.useHtmlNodeOverlay && this.$refs.mindMapNodeOverlay) card = this.$refs.mindMapNodeOverlay.querySelector(selector)
      if (!card && this.$refs.mindMapContainer) card = this.$refs.mindMapContainer.querySelector(selector)
      if (this.selectedNodeKey === key && card && card.classList.contains('node-card--selected')) return
      roots.forEach(function (root) {
        Array.prototype.forEach.call(root.querySelectorAll('.node-card--selected'), function (item) {
          if (item !== card) item.classList.remove('node-card--selected')
        })
      })
      if (card) card.classList.add('node-card--selected')
      this.selectedNodeKey = key
    },
    /**
     * 将五态中文状态转换为节点卡片 class 后缀。
     */
    getStatusClassName: function (status) {
      return 'node-card--status-' + String(status || '未开始').toLowerCase()
    },
    /**
     * 更新已渲染节点卡片的状态 class。
     */
    updateNodeCardStatusClass: function (card, status) {
      if (!card || !card.classList) return
      var classes = Array.prototype.slice.call(card.classList)
      classes.forEach(function (className) {
        if (className.indexOf('node-card--status-') === 0) card.classList.remove(className)
      })
      card.classList.add(this.getStatusClassName(status))
    },
    /**
     * 返回需要参与选中态和状态刷新的节点卡片根节点。
     */
    getNodeCardDomRoots: function () {
      var roots = []
      if (this.$refs.mindMapContainer) roots.push(this.$refs.mindMapContainer)
      if (this.useHtmlNodeOverlay && this.$refs.mindMapNodeOverlay) roots.push(this.$refs.mindMapNodeOverlay)
      return roots
    },
    /**
     * 按选择器同时查询 SVG foreignObject 与 Safari HTML 覆盖层中的节点卡片。
     */
    getNodeCardsBySelector: function (selector) {
      var cards = []
      this.getNodeCardDomRoots().forEach(function (root) {
        Array.prototype.forEach.call(root.querySelectorAll(selector), function (card) {
          if (cards.indexOf(card) === -1) cards.push(card)
        })
      })
      return cards
    },
    /**
     * 将最新状态和进度写回一个已渲染节点卡片。
     */
    applyNodeCardStatus: function (card, row) {
      if (!card || !row) return
      var status = this.getNodeStatus(row)
      var statusInfo = this.getStatusInfo(status)
      var progress = this.getNodeProgress(row, status)
      this.updateNodeCardStatusClass(card, status)
      var statusEl = card.querySelector('.node-status')
      if (statusEl) {
        statusEl.style.background = statusInfo.color
        statusEl.textContent = statusInfo.text
      }
      var progressEl = card.querySelector('.node-progress')
      if (progressEl) {
        progressEl.setAttribute('value', progress)
        progressEl.style.setProperty('--progress-color', statusInfo.color)
        progressEl.style.accentColor = statusInfo.color
      }
    },
    /**
     * 获取节点当前最新业务行，优先使用来源探测后更新过的内存行。
     */
    getLatestNodeRow: function (data) {
      data = data || {}
      var key = this.getNodeSelectionKey(data)
      if (key) {
        for (var i = 0; i < this.internalWorkDetails.length; i++) {
          if (this.getNodeSelectionKey(this.internalWorkDetails[i]) === key) {
            return Object.assign({}, data, this.internalWorkDetails[i], {
              id: data.id || this.internalWorkDetails[i].CODE,
              displayFindDate: data.displayFindDate || '',
              customTextWidth: data.customTextWidth
            })
          }
        }
        if (this.fishboneTaskRow && this.getNodeSelectionKey(this.fishboneTaskRow) === key) {
          return Object.assign({}, data, this.fishboneTaskRow, {
            id: data.id || this.fishboneTaskRow.CODE,
            displayFindDate: data.displayFindDate || '',
            customTextWidth: data.customTextWidth
          })
        }
      }
      if (data.id === 'root') {
        return Object.assign({}, data, this.buildOrderRootData(), this.fishboneProjectRow || {}, {
          id: 'root',
          customTextWidth: data.customTextWidth
        })
      }
      return data
    },
    /**
     * 绑定覆盖层卡片上的节点点击和来源单据 tag 事件。
     */
    bindHtmlOverlayNodeCardEvents: function (card, node, data) {
      if (!card || !node) return
      var self = this
      var row = this.getLatestNodeRow(data)
      card.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('.node-tag')) {
          event.preventDefault()
          event.stopPropagation()
          return
        }
        event.preventDefault()
        event.stopPropagation()
        self.selectedNode = node
        self.updateSelectedNodeStyle(row)
        self.handleNodeClick(row)
      })
      Array.prototype.forEach.call(card.querySelectorAll('.node-tag'), function (tagEl, index) {
        var tag = self.getRefidtyTags(row.REFIDTY)[index]
        var hasPermission = tag && self.hasSourceFormPermission(tag, row, index)
        if (!hasPermission) {
          tagEl.classList.add('node-tag--disabled')
          tagEl.setAttribute('aria-disabled', 'true')
          tagEl.setAttribute('tabindex', '-1')
          tagEl.removeAttribute('role')
          return
        }
        tagEl.classList.remove('node-tag--disabled')
        tagEl.setAttribute('role', 'button')
        tagEl.setAttribute('tabindex', '0')
        tagEl.addEventListener('click', function (event) {
          event.preventDefault()
          event.stopPropagation()
          self.handleRefidtyClick(tag, row, index)
        })
        tagEl.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.stopPropagation()
            self.handleRefidtyClick(tag, row, index)
          }
        })
      })
    },
    /**
     * 读取 simple-mind-map 当前 SVG 画布的变换参数。
     */
    getMindMapDrawTransform: function () {
      var transform = this.mindMap && this.mindMap.draw && typeof this.mindMap.draw.transform === 'function'
        ? this.mindMap.draw.transform()
        : {}
      var scaleX = Number(transform.scaleX)
      if (!scaleX) scaleX = Number(transform.scale) || 1
      var scaleY = Number(transform.scaleY)
      if (!scaleY) scaleY = scaleX
      var translateX = Number(transform.translateX)
      if (isNaN(translateX)) translateX = Array.isArray(transform.translate) ? Number(transform.translate[0]) || 0 : 0
      var translateY = Number(transform.translateY)
      if (isNaN(translateY)) translateY = Array.isArray(transform.translate) ? Number(transform.translate[1]) || 0 : 0
      return {
        scaleX: scaleX,
        scaleY: scaleY,
        translateX: translateX,
        translateY: translateY
      }
    },
    /**
     * 判断节点当前是否处在展开可见路径上。
     */
    isMindMapNodeVisible: function (node) {
      if (!node) return false
      var parent = node.parent
      while (parent) {
        if (parent.getData && parent.getData('expand') === false) return false
        parent = parent.parent
      }
      return true
    },
    /**
     * 获取当前展开状态下的可见节点实例。
     */
    getVisibleMindMapNodes: function () {
      var root = this.mindMap && this.mindMap.renderer && this.mindMap.renderer.root
      var nodes = []
      var self = this
      var walk = function (node) {
        if (!node || !self.isMindMapNodeVisible(node)) return
        nodes.push(node)
        if (node.children && node.children.length && (!node.getData || node.getData('expand') !== false)) {
          node.children.forEach(walk)
        }
      }
      walk(root)
      return nodes
    },
    /**
     * 以节点模型坐标计算当前可见节点整体边界。
     */
    getVisibleMindMapModelRect: function () {
      var nodes = this.getVisibleMindMapNodes().filter(function (node) {
        return Number(node.width) > 0 && Number(node.height) > 0
      })
      if (!nodes.length) return null
      return nodes.reduce(function (acc, node) {
        var left = Number(node.left) || 0
        var top = Number(node.top) || 0
        var width = Number(node.width) || 0
        var height = Number(node.height) || 0
        return {
          left: Math.min(acc.left, left),
          right: Math.max(acc.right, left + width),
          top: Math.min(acc.top, top),
          bottom: Math.max(acc.bottom, top + height)
        }
      }, { left: Infinity, right: -Infinity, top: Infinity, bottom: -Infinity })
    },
    /**
     * 设置 Safari 覆盖层初始隐藏/恢复，避免初始化中间态闪烁。
     */
    setHtmlNodeOverlayVisibility: function (value) {
      var overlay = this.$refs.mindMapNodeOverlay
      if (overlay) overlay.style.visibility = value || ''
    },
    /**
     * 清空 Safari 节点覆盖层。
     */
    clearHtmlNodeOverlay: function () {
      var overlay = this.$refs.mindMapNodeOverlay
      if (overlay) overlay.innerHTML = ''
    },
    /**
     * 取消等待中的覆盖层同步。
     */
    cancelHtmlNodeOverlaySync: function () {
      if (!this.nodeOverlayRenderTimer) return
      if (typeof window !== 'undefined' && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(this.nodeOverlayRenderTimer)
      } else {
        clearTimeout(this.nodeOverlayRenderTimer)
      }
      this.nodeOverlayRenderTimer = null
    },
    /**
     * 在下一帧同步 Safari HTML 覆盖层，拖拽/缩放时避免频繁重建 DOM。
     */
    scheduleHtmlNodeOverlaySync: function () {
      if (!this.useHtmlNodeOverlay) return
      if (this.nodeOverlayRenderTimer) return
      var self = this
      var run = function () {
        self.nodeOverlayRenderTimer = null
        self.syncHtmlNodeOverlay()
      }
      if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
        this.nodeOverlayRenderTimer = window.requestAnimationFrame(run)
      } else {
        this.nodeOverlayRenderTimer = setTimeout(run, 16)
      }
    },
    /**
     * 将 simple-mind-map 的可见节点投影到 Safari HTML 覆盖层。
     */
    syncHtmlNodeOverlay: function () {
      if (!this.useHtmlNodeOverlay) return
      var overlay = this.$refs.mindMapNodeOverlay
      if (!overlay || !this.mindMap || !this.mindMap.renderer || this.mindMap.renderer.isRendering) return
      var transform = this.getMindMapDrawTransform()
      var fragment = document.createDocumentFragment()
      this.getVisibleMindMapNodes().forEach(function (node) {
        if (!node || !node._customNodeContent) return
        var data = (node.nodeData && node.nodeData.data) || {}
        var card = node._customNodeContent.cloneNode(true)
        var row = this.getLatestNodeRow(data)
        var left = (Number(node.left) || 0) * transform.scaleX + transform.translateX
        var top = (Number(node.top) || 0) * transform.scaleY + transform.translateY
        card.classList.add('node-card--overlay')
        card.setAttribute('data-node-overlay', '1')
        card.style.setProperty('left', left + 'px', 'important')
        card.style.setProperty('top', top + 'px', 'important')
        card.style.transformOrigin = 'left top'
        card.style.transform = 'scale(' + transform.scaleX + ', ' + transform.scaleY + ')'
        this.applyNodeCardStatus(card, row)
        this.bindHtmlOverlayNodeCardEvents(card, node, row)
        fragment.appendChild(card)
      }.bind(this))
      overlay.innerHTML = ''
      overlay.appendChild(fragment)
      this.updateSelectedNodeStyle(this.getSelectedNodeData())
    },
    /**
     * 打开或刷新订单流程图，重置探测和详情后加载配置与数据。
     */
    openFishbone: function () {
      this.fishboneLoadRequestId += 1
      this.loadWin = false
      if (this.isMultipleProductMode) {
        this.productRows = []
        this.activeProductRow = {}
        this.productListLoading = true
        this.productSwitching = false
      } else {
        this.resetProductModeState()
      }
      this.resetSourceStatusProbeState()
      this.fishboneProjectRow = this.buildOrderRootData()
      this.resetFishboneDetail()
      if (this.isMultipleProductMode) {
        this.internalWorkDetails = []
        this.orderProcessRows = []
      }
      this.loadFishboneSetup()
      if (!this.isMultipleProductMode) {
        return this.loadFishboneWorkDetails().catch(function (error) {
          this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
          return false
        }.bind(this))
      }

      var requestId = this.beginProductRequest()
      return this.loadProductRows().then(function (rows) {
        if (!this.isCurrentProductRequest(requestId)) return false
        this.productRows = rows
        this.activateFirstProduct()
        if (!this.productRows.length) {
          this.scheduleInitMindMap()
          return false
        }
        return this.reloadFishboneForActiveProduct()
      }.bind(this)).catch(function (error) {
        if (this.isCurrentProductRequest(requestId)) {
          this.showPrompt((error && error.message) || this.$LANG('', '产品列表加载失败'))
        }
        return false
      }.bind(this)).finally(function () {
        if (this.isCurrentProductRequest(requestId)) this.productListLoading = false
      }.bind(this))
    },
    /**
     * 使用当前选中产品重新加载流程，成功前保留旧图，失败交由调用方回滚。
     */
    reloadFishboneForActiveProduct: function () {
      this.resetSourceStatusProbeState()
      this.resetFishboneDetail()
      return this.loadFishboneWorkDetails()
    },
    /**
     * 方框控件保持单选：当前项不能取消，其他项点击后按产品主键刷新流程。
     */
    handleProductSelectionChange: function (row) {
      var key = this.getProductKey(row)
      if (key === this.getProductKey(this.activeProductRow)) return
      this.selectProductByKey(key).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('', '产品流程加载失败'))
      }.bind(this))
    },
    /**
     * 主弹窗已显示但 opened 事件未触发时兜底初始化画布。
     */
    ensureMainDialogOpened: function () {
      if (!this.drawer || !this.innerVisible) return
      var self = this
      this.$nextTick(function () {
        setTimeout(function () {
          if (self.drawer && self.innerVisible && !self.mainDialogOpened) self.handleMainDialogOpened()
        }, 80)
      })
    },
    ensureDrawerOpened: function () {
      this.ensureMainDialogOpened()
    },
    /**
     * 加载流程图通用配置、表单必填规则、员工选择列和权限。
     */
    loadFishboneSetup: function () {
      if (this.fishboneSetupLoaded) return
      this.fishboneSetupLoaded = true
      this.loadBaseRows({
        p_key: 'PARENTNO',
        p_value: '462299',
        p_table: 'v_sys_base'
      }).then(function (rows) {
        this.stfgArr = rows
      }.bind(this))
      this.loadTableRows('v_sys_form_fld', 'idseq', '17437', 'LSTSEQ', '6', 'NOTNULL', 'Y').then(function (rows) {
        var ruleObj = {}
        this.logNull = rows
        rows.forEach(function (item) {
          var fieldName = this.$translate.getColTitle(item, this.$store.state.lang)
          ruleObj[item.FLDNO] = [{ required: true, message: fieldName + this.$LANG('2051', '不能为空'), trigger: 'blur' }]
        }.bind(this))
        this.logValidate = ruleObj
      }.bind(this))
      this.loadEmployeeSelectColumns()
      this.loadNodeAddSetup()
      this.loadSourceFormPermissions()
      this.loadBaseRows({
        p_key: 'userno',
        p_value: this.vUsername,
        p_key2: 'frmidseq',
        p_value2: '17437',
        p_table: 'v_sys_user_priv'
      }).then(function (rows) {
        if (this.vAdmin !== 'N' || !rows.length) return
        var row = rows[0]
        this.addBool = row.ISADD === 'N'
        this.editBool = row.ISUPD === 'N'
        this.delBool = row.ISDEL === 'N'
        if (this.enableNodeAdd && this.mindMap) this.scheduleInitMindMap()
      }.bind(this))
    },
    /**
     * 加载当前用户拥有查看权限的表单列表，来源单据 tag 只允许打开这些表单。
     */
    loadSourceFormPermissions: function () {
      if (this.vAdmin !== 'N') {
        this.sourceFormPermissionMap = {}
        this.sourceFormPermissionLoaded = true
        return Promise.resolve()
      }
      this.sourceFormPermissionLoaded = false
      return this.loadBaseRows({
        p_key: 'userno',
        p_value: this.vUsername,
        p_key2: 'issel',
        p_value2: 'Y',
        p_table: 'v_sys_user_priv'
      }).then(function (rows) {
        var permissionMap = {}
        rows.forEach(function (row) {
          var formId = row.FRMIDSEQ || row.frmidseq || row.FRMID || row.frmid || ''
          formId = String(formId || '').trim()
          if (formId) permissionMap[formId] = true
        })
        this.sourceFormPermissionMap = permissionMap
        this.sourceFormPermissionLoaded = true
        if (this.mindMap) this.scheduleInitMindMap()
      }.bind(this)).catch(function () {
        this.sourceFormPermissionMap = {}
        this.sourceFormPermissionLoaded = true
        if (this.mindMap) this.scheduleInitMindMap()
      }.bind(this))
    },
    /**
     * 加载负责人选择弹窗的列配置。
     */
    loadEmployeeSelectColumns: function () {
      return this.loadTableRows('v_sys_form_fld', 'idseq', '17437', 'lstseq', '2', '', '', ' order by sortby,lstseq').then(function (rows) {
        this.empSelectColumns = rows.map(function (item) {
          return {
            title: this.$translate.getColTitle(item, this.$store.state.lang),
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            fhide: item.FHIDE,
            edcss: item.EDCSS,
            disabled: item.DISABLED,
            dotnum: item.DOTNUM,
            sortable: item.SORTABLE,
            notnull: item.NOTNULL
          }
        }.bind(this))
        return this.empSelectColumns
      }.bind(this))
    },
    /**
     * 打开任务负责人选择弹窗，列配置缺失时先补加载。
     */
    openProcessOwnerSelect: function () {
      if (this.isReadonlyMode) return
      if (!this.empSelectColumns.length) {
        this.loadEmployeeSelectColumns().then(function () {
          this.openProcessOwnerSelect()
        }.bind(this)).catch(function (error) {
          this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
        }.bind(this))
        return
      }
      this.empSelectTable = 'v_HR_EMP'
      this.empSelectKey2 = 'STFG'
      this.empSelectValue2 = 'Y'
      this.empSelectRandom = Date.now()
      this.empSelectWin = true
    },
    /**
     * 将员工选择结果回填到进度维护表单。
     */
    handleProcessOwnerSelected: function (row) {
      row = row || {}
      this.processOwner = row.EMPNM || ''
      this.processOwnerEmpId = row.IDSEQ || ''
      this.empSelectWin = false
    },
    /**
     * 加载订单流程骨架和维护记录，并合并为可渲染节点列表。
     */
    loadFishboneWorkDetails: function () {
      var requestId = ++this.fishboneLoadRequestId
      var taskIdentity = this.getOrderTaskQueryIdentity()
      if (!taskIdentity.refIdseq || !taskIdentity.refLstseq) {
        this.internalWorkDetails = []
        this.orderProcessRows = []
        this.fishboneProjectRow = this.buildOrderRootData()
        this.scheduleInitMindMap()
        return Promise.reject(new Error(this.$LANG('', '当前订单主键为空，不能加载流程图')))
      }
      this.loadWin = true
      return Promise.all([this.loadOrderTaskRows(), this.loadOrderProcessRows()]).then(function (result) {
        if (requestId !== this.fishboneLoadRequestId) return false
        var rows = result[0] || []
        this.fishboneProjectRow = this.buildOrderRootData()
        this.orderProcessRows = result[1] || []
        this.internalWorkDetails = this.applyCachedSourceStatuses(this.mergeOrderProcessRows(rows, this.orderProcessRows))
        this.scheduleInitMindMap()
        return this.scheduleSourceStatusProbe(this.internalWorkDetails).then(function () {
          return requestId === this.fishboneLoadRequestId
        }.bind(this))
      }.bind(this)).finally(function () {
        if (requestId === this.fishboneLoadRequestId) this.loadWin = false
      }.bind(this))
    },
    /**
     * 清空当前详情侧栏和附件数据。
     */
    resetFishboneDetail: function () {
      this.selectedNode = null
      this.fishboneDetailVisible = false
      this.fishboneDetailNode = null
      this.fishboneTaskRow = {}
      this.fishboneTaskAttachments = []
      this.fishboneLogList = []
      this.fishboneRootAttachments = []
      this.detailPanelCollapsed = false
      this.detailPanelLockedCollapsed = false
    },
    /**
     * 关闭或切换订单时重置流程图全部临时状态。
     */
    resetFishboneState: function () {
      this.fishboneLoadRequestId += 1
      this.resetProductModeState()
      this.resetSourceStatusProbeState()
      this.mainDialogOpened = false
      this.resetFishboneDetail()
      this.closeSourceDialogs()
      this.logWin = false
      this.pctWin = false
      this.empSelectWin = false
      this.resetNodeAddState()
      this.promptWin = false
      this.loadWin = false
      this.videoFlag = false
      this.videoUploadPercent = 0
      this.internalWorkDetails = []
      this.orderProcessRows = []
      this.destroyMindMap()
    },
    /**
     * 判断思维导图容器是否已经进入可渲染状态。
     */
    isMindMapContainerReady: function (container) {
      if (!container) return false
      if (!document.body.contains(container)) return false
      if (this.drawer && (!this.innerVisible || !this.mainDialogOpened)) return false
      return true
    },
    /**
     * 延迟初始化思维导图，合并同一轮内的多次刷新请求。
     */
    scheduleInitMindMap: function () {
      var self = this
      var token = ++this.mindMapRenderToken
      if (this.initMindMapTimer) {
        clearTimeout(this.initMindMapTimer)
        this.initMindMapTimer = null
      }
      this.$nextTick(function () {
        self.initMindMapTimer = setTimeout(function () {
          self.initMindMapTimer = null
          self.initMindMap(token)
        }, 0)
      })
    },
    /**
     * 安排来源单据状态探测，并用 token 防止旧批次回写。
     */
    scheduleSourceStatusProbe: function (rows) {
      var token = ++this.sourceProbeToken
      this.sourceProbeInFlight = {}
      return new Promise(function (resolve) {
        this.$nextTick(function () {
          resolve(this.runSourceStatusProbe(rows || this.internalWorkDetails || [], token))
        }.bind(this))
      }.bind(this))
    },
    /**
     * 执行来源单据探测，将命中状态写回缓存、节点数据和已渲染卡片。
     */
    runSourceStatusProbe: function (rows, token) {
      if (token !== this.sourceProbeToken) return Promise.resolve(false)
      var probes = []
      this.normalizeRows(rows).forEach(function (row) {
        if (!this.shouldProbeSourceStatus(row)) return
        var key = this.getNodeSelectionKey(row)
        if (!key || this.sourceProbeInFlight[key]) return
        this.sourceProbeInFlight[key] = true
        probes.push(this.probeNodeSourceStatus(row).then(function (status) {
          if (token !== this.sourceProbeToken) return
          this.$set(this.sourceStatusMap, key, status || '未开始')
          this.applySourceStatusToRow(key, status || '未开始')
          this.updateRenderedNodeStatus(key)
        }.bind(this)).catch(function () {
          if (token !== this.sourceProbeToken) return
          this.$set(this.sourceStatusMap, key, '未开始')
          this.applySourceStatusToRow(key, '未开始')
          this.updateRenderedNodeStatus(key)
        }.bind(this)).finally(function () {
          if (token === this.sourceProbeToken) this.$delete(this.sourceProbeInFlight, key)
        }.bind(this)))
      }.bind(this))
      return Promise.all(probes)
    },
    /**
     * 判断节点是否需要探测来源单据状态。
     */
    shouldProbeSourceStatus: function (row) {
      if (!this.hasRefDoc(row)) return false
      if (Number(row && row.PCT) >= 100) return false
      var key = this.getNodeSelectionKey(row)
      if (!key) return false
      return this.sourceStatusMap[key] === undefined
    },
    /**
     * 获取节点已缓存的来源单据探测状态。
     */
    getCachedSourceStatus: function (row) {
      var key = this.getNodeSelectionKey(row)
      if (!key) return ''
      return Object.prototype.hasOwnProperty.call(this.sourceStatusMap, key) ? this.sourceStatusMap[key] : ''
    },
    /**
     * 将来源单据探测缓存合并到节点列表。
     */
    applyCachedSourceStatuses: function (rows) {
      return this.normalizeRows(rows).map(function (item) {
        var cachedStatus = this.getCachedSourceStatus(item)
        if (!cachedStatus || Number(item && item.PCT) >= 100) return item
        return Object.assign({}, item, {
          SOURCE_STFG: cachedStatus,
          DISPLAY_STFG: this.getNodeStatus(Object.assign({}, item, { SOURCE_STFG: cachedStatus }))
        })
      }.bind(this))
    },
    /**
     * 将单个来源单据探测结果同步到内存节点和详情节点。
     */
    applySourceStatusToRow: function (key, status) {
      this.internalWorkDetails = this.internalWorkDetails.map(function (item) {
        if (this.getNodeSelectionKey(item) === key) {
          return Object.assign({}, item, {
            SOURCE_STFG: status,
            DISPLAY_STFG: this.getNodeStatus(Object.assign({}, item, { SOURCE_STFG: status }))
          })
        }
        return item
      }.bind(this))
      if (this.fishboneTaskRow && this.getNodeSelectionKey(this.fishboneTaskRow) === key) {
        this.fishboneTaskRow = Object.assign({}, this.fishboneTaskRow, {
          SOURCE_STFG: status,
          DISPLAY_STFG: this.getNodeStatus(Object.assign({}, this.fishboneTaskRow, { SOURCE_STFG: status }))
        })
      }
      if (this.currentDetailNode && this.currentDetailNode.key === key && this.currentDetailNode.raw) {
        this.currentDetailNode.raw = Object.assign({}, this.currentDetailNode.raw, {
          SOURCE_STFG: status,
          DISPLAY_STFG: this.getNodeStatus(Object.assign({}, this.currentDetailNode.raw, { SOURCE_STFG: status }))
        })
      }
    },
    /**
     * 清除某个节点的来源单据缓存，让后续刷新重新探测。
     */
    clearSourceStatusForRow: function (row) {
      var key = this.getNodeSelectionKey(row)
      if (!key) return
      this.$delete(this.sourceStatusMap, key)
      this.$delete(this.sourceProbeInFlight, key)
    },
    /**
     * 来源单据弹窗保存、审核或下推后，刷新当前节点来源状态。
     */
    handleSourceDialogChanged: function () {
      var row = (this.sourceDialogNode && this.sourceDialogNode.nodeData) || (this.currentDetailNode && (this.currentDetailNode.nodeData || this.currentDetailNode.raw)) || this.currentTaskRow || {}
      var key = this.getNodeSelectionKey(row)
      if (!key) return
      this.clearSourceStatusForRow(row)
      this.probeNodeSourceStatus(row).then(function (status) {
        var nextStatus = status || '未开始'
        this.$set(this.sourceStatusMap, key, nextStatus)
        this.applySourceStatusToRow(key, nextStatus)
        this.updateRenderedNodeStatus(key)
      }.bind(this)).catch(function () {
        this.scheduleSourceStatusProbe([row])
      }.bind(this))
    },
    /**
     * 在不重建整张图的情况下更新已渲染节点的状态和进度。
     */
    updateRenderedNodeStatus: function (key) {
      var row = null
      for (var i = 0; i < this.internalWorkDetails.length; i++) {
        if (this.getNodeSelectionKey(this.internalWorkDetails[i]) === key) {
          row = this.internalWorkDetails[i]
          break
        }
      }
      if (!row) return
      var status = this.getNodeStatus(row)
      var progress = this.getNodeProgress(row, status)
      var selector = '.node-card[data-node-key="' + String(key).replace(/"/g, '\\"') + '"]'
      var cards = this.getNodeCardsBySelector(selector)
      if (!cards.length) {
        this.scheduleInitMindMap()
        return
      }
      cards.forEach(function (card) {
        this.applyNodeCardStatus(card, row)
      }.bind(this))
      if (this.selectedNode && this.selectedNode.nodeData && this.selectedNode.nodeData.data && this.getNodeSelectionKey(this.selectedNode.nodeData.data) === key) {
        this.selectedNode.nodeData.data = Object.assign({}, this.selectedNode.nodeData.data, row, {
          DISPLAY_STFG: status,
          SOURCE_STFG: row.SOURCE_STFG || '',
          progress: progress
        })
      }
    },
    /**
     * 初始化或刷新 simple-mind-map 实例，并创建订单节点自定义 DOM。
     */
    initMindMap: function (token) {
      if (token === undefined) token = ++this.mindMapRenderToken
      if (token !== this.mindMapRenderToken) return
      if (this.drawer && (!this.innerVisible || !this.mainDialogOpened)) return
      var container = this.$refs.mindMapContainer
      if (!this.isMindMapContainerReady(container)) return
      var rect = container.getBoundingClientRect()
      var self = this
      if (rect.width === 0 || rect.height === 0) {
        this.initMindMapTimer = setTimeout(function () { self.initMindMap(token) }, 300)
        return
      }
      if (token !== this.mindMapRenderToken || !this.isMindMapContainerReady(container)) return
      var dataToUse = this.internalWorkDetails && this.internalWorkDetails.length > 0 ? this.internalWorkDetails : []
      try {
        // 先隐藏容器完成数据和实例刷新，再由 fitView 恢复显示，避免用户看到中间态跳动。
        this.flowData = this.buildFlowData(dataToUse)
        container.style.visibility = 'hidden'
        this.setHtmlNodeOverlayVisibility('hidden')
        this.clearHtmlNodeOverlay()
        if (this.mindMap && this.mindMap.el === container && typeof this.mindMap.setData === 'function') {
          this.clearMindMapInnerTimers(this.mindMap)
          this.mindMap.setData(this.flowData)
          this.scheduleFitView()
          return
        }
        if (this.mindMap) {
          try {
            this.clearMindMapInnerTimers(this.mindMap)
            this.mindMap.destroy && this.mindMap.destroy()
          } catch (e) {
            console.warn('销毁思维导图实例失败:', e)
          }
        }
        if (token !== this.mindMapRenderToken || !this.isMindMapContainerReady(container)) return
        container.innerHTML = ''
        this.mindMap = new MindMap({
          el: container,
          theme: 'earthYellow',
          draggable: true,
          data: this.flowData,
          layout: 'timeline2',
          readonly: true,
          fit: false,
          alwaysShowExpandBtn: true,
          notShowExpandBtn: false,
          expandBtnSize: 20,
          hoverRectPadding: 0,
          themeConfig: {
            lineWidth: 3,
            root: { borderWidth: 0, borderColor: 'transparent', fillColor: 'transparent', borderRadius: 18, hoverRectColor: 'transparent', hoverRectRadius: 18 },
            second: { borderWidth: 0, borderColor: 'transparent', fillColor: 'transparent', borderRadius: 18, hoverRectColor: 'transparent', hoverRectRadius: 18 },
            node: { fontWeight: 'bold', fontSize: 12, fontFamily: '微软雅黑, Microsoft YaHei', marginY: 9, borderWidth: 0, borderColor: 'transparent', fillColor: 'transparent', borderRadius: 18, hoverRectColor: 'transparent', hoverRectRadius: 18 }
          },
          isUseCustomNodeContent: true,
          customCreateNodeContent: function (node) {
            // simple-mind-map 的自定义节点内容由原生 DOM 构造，避免模板编译开销。
            var data = node.nodeData.data || {}
            var displayStatus = data.DISPLAY_STFG || self.getDisplayStatus(data)
            var statusInfo = self.getStatusInfo(displayStatus)
            var progress = self.getNodeProgress(data, displayStatus)
            var progressColor = statusInfo.color || (progress < 50 ? '#999' : progress < 100 ? '#E6A23C' : '#28a745')
            var refTags = self.getRefidtyTags(data.REFIDTY)
            var nodeOwner = String(data.EMPNM || data.EMPNM2 || '').trim()
            var isCurrentUserNode = nodeOwner && nodeOwner === self.vUsernm
            var el = document.createElement('div')
            var nodeKey = self.getNodeSelectionKey(data)
            var nodeBusinessKey = self.getRenderedNodeBusinessKey(data)
            var nodeUid = node.uid || data.uid || ''
            var nodeRenderWidth = Number(data.customTextWidth) || self.getNodeCardRenderWidth(data)
            el.className = 'node-card ' + self.getStatusClassName(displayStatus) + (data.id === 'root' ? ' node-card--root' : '')
            el.setAttribute('data-node-key', nodeKey)
            if (nodeBusinessKey) el.setAttribute('data-node-business-key', nodeBusinessKey)
            if (nodeUid) el.setAttribute('data-node-uid', String(nodeUid))
            el.setAttribute('data-node-render-seq', String(++self.nodeContentRenderSeq))
            el.setAttribute('data-node-render-width', String(nodeRenderWidth))
            el.style.setProperty('--node-card-width', nodeRenderWidth + 'px')
            if (isCurrentUserNode) el.className += ' node-card--mine'
            var createProgressRow = function (isRootNode) {
              var progressRowEl = document.createElement('div')
              progressRowEl.className = 'node-progress-row'
              var progressEl = document.createElement('progress')
              progressEl.className = 'node-progress'
              progressEl.setAttribute('data-node-progress', '1')
              progressEl.setAttribute('max', '100')
              progressEl.setAttribute('value', progress)
              progressEl.style.setProperty('--progress-color', progressColor)
              progressEl.style.accentColor = progressColor
              progressRowEl.appendChild(progressEl)
              return progressRowEl
            }

            if (data.id === 'root') {
              // 根节点展示订单概览信息，和普通任务节点的布局不同。
              var isOrderRoot = data.NODETY === 'ORDER'
              var rootTitleEl = document.createElement('div')
              rootTitleEl.className = 'node-header node-header--root'
              var rootTitleText = data.NODETITLE || data.TASKNM || data.WKNM || (isOrderRoot ? '生产订单' : '项目')
              var rootTitleTextEl = document.createElement('span')
              rootTitleTextEl.className = 'node-title node-title--root'
              rootTitleTextEl.textContent = rootTitleText
              rootTitleEl.appendChild(rootTitleTextEl)
              if (isOrderRoot && nodeOwner) {
                var rootInlineOwnerEl = document.createElement('span')
                rootInlineOwnerEl.className = 'node-owner-tag node-owner-tag--inline' + (isCurrentUserNode ? ' node-owner-tag--mine' : '')
                rootInlineOwnerEl.textContent = nodeOwner
                rootTitleEl.appendChild(rootInlineOwnerEl)
              }
              el.appendChild(rootTitleEl)

              if (isOrderRoot) {
                var orderInfoList = [
                  { label: '客户代码', value: data.CLNT_IDNO },
                  { label: '交货日期', value: data.SHPDTTM || data.FINDTTM },
                  { label: '产品名称', value: data.MATNM },
                  { label: '订单数量', value: data.QTY },
                  { label: '生产数量', value: data.PCQTY },
                  { label: '入库数量', value: data.INQTY }
                ]
                orderInfoList.forEach(function (item) {
                  if (item.value === undefined || item.value === null || item.value === '') return
                  var infoEl = document.createElement('div')
                  infoEl.className = 'node-order-info'
                  infoEl.textContent = item.label + '：' + item.value
                  el.appendChild(infoEl)
                })
              }

              if (!isOrderRoot && (data.EMPNM || data.EMPNM2)) {
                var rootOwnerEl = document.createElement('div')
                rootOwnerEl.className = 'node-owner'
                rootOwnerEl.textContent = data.EMPNM || data.EMPNM2 || ''
                el.appendChild(rootOwnerEl)
              }

              var rootStatusWrapEl = document.createElement('div')
              rootStatusWrapEl.className = 'node-status-row'
              var rootStatusEl = document.createElement('span')
              rootStatusEl.className = 'node-status'
              rootStatusEl.setAttribute('data-node-status', '1')
              rootStatusEl.style.background = statusInfo.color
              rootStatusEl.textContent = statusInfo.text
              rootStatusWrapEl.appendChild(rootStatusEl)
              el.appendChild(rootStatusWrapEl)

              if (isOrderRoot) {
                el.appendChild(createProgressRow(true))
                return el
              }

              if (data.DTTM) {
                var rootStartDateEl = document.createElement('div')
                rootStartDateEl.className = 'node-date node-date--root'
                rootStartDateEl.textContent = '立项：' + data.DTTM
                el.appendChild(rootStartDateEl)
              }

              if (data.FINDTTM) {
                var rootEndDateEl = document.createElement('div')
                rootEndDateEl.className = 'node-date node-date--root'
                rootEndDateEl.textContent = '截止：' + data.FINDTTM
                el.appendChild(rootEndDateEl)
              }

              el.appendChild(createProgressRow(true))

              return el
            }

            // 普通任务节点展示工序名称、负责人、来源单据入口、状态和进度。
            var headerEl = document.createElement('div')
            headerEl.className = 'node-header'
            var titleEl = document.createElement('span')
            titleEl.className = 'node-title'
            var titleTextEl = document.createElement('span')
            titleTextEl.textContent = data.WKNM || '项目'
            titleEl.appendChild(titleTextEl)
            headerEl.appendChild(titleEl)
            if (nodeOwner) {
              var titleOwnerTagEl = document.createElement('span')
              titleOwnerTagEl.className = 'node-owner-tag node-owner-tag--inline' + (isCurrentUserNode ? ' node-owner-tag--mine' : '')
              titleOwnerTagEl.textContent = nodeOwner
              headerEl.appendChild(titleOwnerTagEl)
            }
            el.appendChild(headerEl)

            if ((data.displayFindDate || data.FINDTTM) || refTags.length) {
              var metaEl = document.createElement('div')
              metaEl.className = 'node-meta'

              if (data.displayFindDate || data.FINDTTM) {
                var dateEl = document.createElement('div')
                dateEl.className = 'node-date'
                dateEl.textContent = data.displayFindDate || data.FINDTTM || ''
                metaEl.appendChild(dateEl)
              }

              if (refTags.length) {
                var tagsEl = document.createElement('div')
                tagsEl.className = 'node-tags'
                refTags.forEach(function (tag, index) {
                  var tagEl = document.createElement('span')
                  var hasPermission = self.hasSourceFormPermission(tag, data, index)
                  tagEl.className = 'node-tag' + (hasPermission ? '' : ' node-tag--disabled')
                  tagEl.textContent = self.getRefidtyTagText(tag)
                  if (hasPermission) {
                    tagEl.setAttribute('role', 'button')
                    tagEl.setAttribute('tabindex', '0')
                    tagEl.addEventListener('click', function (event) {
                      event.preventDefault()
                      event.stopPropagation()
                      self.handleRefidtyClick(tag, data, index)
                    })
                    tagEl.addEventListener('keydown', function (event) {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault()
                        event.stopPropagation()
                        self.handleRefidtyClick(tag, data, index)
                      }
                    })
                  } else {
                    tagEl.setAttribute('aria-disabled', 'true')
                    tagEl.setAttribute('tabindex', '-1')
                  }
                  tagsEl.appendChild(tagEl)
                })
                metaEl.appendChild(tagsEl)
              }

              el.appendChild(metaEl)
            }

            var statusWrapEl = document.createElement('div')
            statusWrapEl.className = 'node-status-row'
            var statusEl = document.createElement('span')
            statusEl.className = 'node-status'
            statusEl.setAttribute('data-node-status', '1')
            statusEl.style.background = statusInfo.color
            statusEl.textContent = statusInfo.text
            statusWrapEl.appendChild(statusEl)
            el.appendChild(statusWrapEl)

            el.appendChild(createProgressRow(false))

            return el
          }
        })
        if (token !== this.mindMapRenderToken || !this.isMindMapContainerReady(container)) {
          this.destroyMindMap()
          return
        }
        this.bindMindMapRenderGuards(this.mindMap)
        this.startContainerResizeObserver()
        this.scheduleFitView()
        this.mindMap.on('node_click', function (node) {
          var data = (node.nodeData && node.nodeData.data) || {}
          self.selectedNode = node
          self.updateSelectedNodeStyle(data)
          self.handleNodeClick(data)
        })
      } catch (e) {
        console.error('初始化思维导图失败:', e)
      }
    },
    /**
     * 将订单任务列表转换为 simple-mind-map 所需的树形数据。
     */
    buildFlowData: function (list) {
      var map = {}
      // CODE 使用层级编码，拆分后用于控制默认展开深度。
      var getLevel = function (item) {
        if (!item || !item.CODE) return 1
        return String(item.CODE).split('-').length + 1
      }
      var getLineColorByStatus = this.getLineColorByStatus.bind(this)
      var getNodeStatus = this.getNodeStatus.bind(this)
      var getNodeProgress = this.getNodeProgress.bind(this)
      var getNodeCardRenderWidth = this.getNodeCardRenderWidth.bind(this)
      list.forEach(function (item) {
        var datePart = ''
        var level = getLevel(item)
        var displayStatus = getNodeStatus(item)
        var nodeOwner = item.EMPNM || item.EMPNM2 || ''
        if (item.FINDTTM) {
          var parts = item.FINDTTM.split('-')
          if (parts.length >= 3) datePart = parts[1] + '-' + parts[2]
        }
        map[item.CODE] = {
          data: Object.assign({}, item, {
            id: item.CODE,
            text: item.WKNM + (nodeOwner ? ' [' + nodeOwner + ']' : '') + (datePart ? ' ' + datePart : ''),
            WKNM: item.WKNM,
            EMPNM: nodeOwner,
            EMPNM2: nodeOwner,
            displayFindDate: datePart,
            DISPLAY_STFG: displayStatus,
            borderWidth: 0,
            borderColor: 'transparent',
            borderDasharray: 'none',
            lineColor: getLineColorByStatus(displayStatus),
            lineWidth: 3,
            borderRadius: 18,
            customTextWidth: getNodeCardRenderWidth(Object.assign({}, item, { id: item.CODE, EMPNM: nodeOwner, EMPNM2: nodeOwner })),
            expand: level <= 2,
            progress: getNodeProgress(item, displayStatus)
          }),
          children: []
        }
      })
      var rootSource = Object.assign({}, this.buildOrderRootData(), this.fishboneProjectRow || {})
      var projectName = rootSource.NODETITLE || rootSource.TASKNM || rootSource.WKNM || this.$LANG('', '生产订单')
      var projectOwner = rootSource.EMPNM || rootSource.EMPNM2 || ''
      var projectStatus = this.normalizeOrderStatus(rootSource.STFG || rootSource.DISPLAY_STFG, Number(rootSource.PCT) || 0)
      var projectProgress = rootSource.PCT || rootSource.progress || 0
      var root = {
        data: Object.assign({}, rootSource, {
          text: projectName + (projectOwner ? ' [' + projectOwner + ']' : ''),
          TASKNM: projectName,
          WKNM: projectName,
          EMPNM: projectOwner,
          FINDTTM: rootSource.FINDTTM || '',
          DTTM: rootSource.DTTM || '',
          STFG: projectStatus,
          DISPLAY_STFG: projectStatus,
          id: 'root',
          borderWidth: 0,
          borderColor: 'transparent',
          borderDasharray: 'none',
          lineColor: this.getLineColorByStatus(projectStatus),
          lineWidth: 3,
          borderRadius: 18,
          fillColor: 'transparent',
          customTextWidth: getNodeCardRenderWidth(Object.assign({}, rootSource, { id: 'root', EMPNM: projectOwner, EMPNM2: projectOwner })),
          progress: projectProgress
        }),
        children: []
      }
      // 按 PARENTNO 把扁平订单任务挂接到根节点或父节点。
      list.forEach(function (item) {
        if (item.PARENTNO === '#' || !item.PARENTNO) {
          if (map[item.CODE]) root.children.push(map[item.CODE])
        } else if (map[item.PARENTNO]) {
          map[item.PARENTNO].children.push(map[item.CODE])
        }
      })
      return root
    },
    /**
     * 获取节点最终展示状态，维护记录、逾期和来源单据探测结果在这里收敛为五态。
     */
    getNodeStatus: function (item) {
      item = item || {}
      var status = this.normalizeOrderStatus(item.STFG, Number(item.PCT) || 0)
      if (status === '已完成' || status === '已终止' || status === '已逾期') return status
      if (this.isOverdue(this.getOrderProcessFindDate(item))) return '已逾期'
      if (this.hasRefDoc(item)) {
        var sourceStatus = this.normalizeOrderStatus(item.SOURCE_STFG || '', 0)
        return sourceStatus === '进行中' ? '进行中' : status
      }
      return status
    },
    /**
     * 获取基础展示状态，用于不需要来源单据探测的场景。
     */
    getDisplayStatus: function (item) {
      item = item || {}
      var status = this.normalizeOrderStatus(item.STFG, Number(item.PCT) || 0)
      if (this.isOverdue(item.FINDTTM) && status !== '已完成' && status !== '已终止') return '已逾期'
      return status
    },
    /**
     * 判断状态是否等价于已完成。
     */
    isCompletedStatus: function (stfg) {
      return this.normalizeOrderStatus(stfg, 0) === '已完成'
    },
    /**
     * 判断 yyyy-MM-dd 日期是否早于今天。
     */
    isOverdue: function (dateValue) {
      if (!dateValue) return false
      var dateText = String(dateValue).trim().slice(0, 10)
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateText)) return false
      var today = new Date()
      var todayText = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0')
      return dateText < todayText
    },
    /**
     * 将五态中文状态映射为展示文案和颜色。
     */
    getStatusInfo: function (stfg) {
      switch (stfg) {
        case '进行中':
          return { text: '进行中', color: '#ff9500' }
        case '已完成':
          return { text: '已完成', color: '#34c759' }
        case '已终止':
          return { text: '已终止', color: '#ff3b30' }
        case '已逾期':
          return { text: '已逾期', color: '#ff3b30' }
        case '未开始':
        default:
          return { text: '未开始', color: '#8e8e93' }
      }
    },
    /**
     * 获取连线颜色，和节点状态颜色保持一致。
     */
    getLineColorByStatus: function (stfg) {
      return this.getStatusInfo(stfg).color
    },
    /**
     * 计算节点进度条数值，优先使用后端进度，缺失时按五态给默认值。
     */
    getNodeProgress: function (item, status) {
      item = item || {}
      if (item.PCT !== undefined && item.PCT !== null && item.PCT !== '') return Number(item.PCT) || 0
      if (item.progress !== undefined && item.progress !== null && item.progress !== '') return Number(item.progress) || 0
      if (status === '已完成') return 100
      if (status === '进行中') return 50
      return 0
    },
    /**
     * 将来源单据类型字符串拆成可点击标签。
     */
    getRefidtyTags: function (refidty) {
      if (!refidty) return []
      return String(refidty)
        .split(',')
        .map(function (item) { return item.trim() })
        .filter(function (item) { return item })
    },
    /**
     * 按来源 tag 的下标取得对应表单 ID。
     */
    getRefidtyFormId: function (data, index) {
      data = data || {}
      var formIds = String(data.REFIDTYNM || '')
        .split(',')
        .map(function (item) { return item.trim() })
      return formIds[index || 0] || ''
    },
    /**
     * 兼容旧节点或来源 tag 直接存业务类型，而不是表单 ID 的情况。
     */
    normalizeSourceFormId: function (value) {
      var text = String(value || '').trim()
      var upperText = text.toUpperCase()
      if (text === '来料质检单' || upperText === 'QACHK') return '450125'
      if (text === '质检入库单' || upperText === 'POIN') return '112'
      if (text === '制程巡检记录') return '412735'
      if (text === '成品检验报告') return '412736'
      return text
    },
    /**
     * 判断当前用户是否有来源表单查看权限。
     */
    hasSourceFormPermission: function (tag, data, index) {
      var formId = this.getRefidtyFormId(data, index) || tag
      return this.hasSourceFormIdPermission(formId)
    },
    /**
     * 直接按表单 ID 判断当前用户是否有查看权限。
     */
    hasSourceFormIdPermission: function (formId) {
      if (this.vAdmin !== 'N') return true
      if (!this.sourceFormPermissionLoaded) return false
      formId = this.normalizeSourceFormId(formId)
      if (!formId) return false
      return !!this.sourceFormPermissionMap[formId]
    },
    /**
     * 当前详情侧栏的来源单据按钮是否需要禁用。
     */
    isCurrentRefDocumentDisabled: function () {
      if (!this.currentDetailNode || !this.currentDetailNode.refidty) return true
      if (this.currentDetailNode.refCount && this.currentDetailNode.refCount > 1) return false
      return !this.hasSourceFormPermission(this.currentDetailNode.refidty, this.currentDetailNode.nodeData || this.currentDetailNode.raw || {}, 0)
    },
    /**
     * 转换来源单据标签的展示文案。
     */
    getRefidtyTagText: function (tag) {
      var tagText = String(tag || '').trim()
      if (tagText === '生产任务单') return '生产投料单'
      return tagText
    },
    /**
     * 将节点原始数据整理为详情侧栏使用的统一载荷。
     */
    normalizeNodePayload: function (data) {
      var isRoot = data && data.id === 'root'
      var taskIdentity = this.getOrderProcessTaskIdentity(data)
      var templateIdentity = this.getOrderTaskIdentity(data)
      return {
        type: isRoot ? 'root' : 'task',
        code: data.CODE || data.id || '',
        idseq: data.IDSEQ || '',
        lstseq: data.LSTSEQ || '',
        taskIdseq: taskIdentity.taskIdseq,
        taskLstseq: taskIdentity.taskLstseq,
        templateIdseq: templateIdentity.taskIdseq,
        templateLstseq: templateIdentity.taskLstseq,
        refidty: data.REFIDTY || '',
        refidtynm: data.REFIDTYNM || '',
        refidno: data.REFIDNO || '',
        nodeData: data,
        raw: data
      }
    },
    /**
     * 判断节点是否有关联来源单据。
     */
    hasRefDoc: function (data) {
      return !!(data && data.id !== 'root' && data.REFIDTY)
    },
    /**
     * 处理节点点击，更新选中态并加载根节点或任务节点详情。
     */
    handleNodeClick: function (data) {
      var payload = this.normalizeNodePayload(data)
      var nodeKey = this.getNodeSelectionKey(data)
      if (this.hasRefDoc(data)) payload.refCount = this.getRefidtyTags(data.REFIDTY).length
      if (this.detailPanelLockedCollapsed) {
        this.detailPanelCollapsed = false
        this.detailPanelLockedCollapsed = false
      }
      if (this.fishboneDetailVisible && this.currentDetailNode && this.currentDetailNode.key === nodeKey) return
      payload.key = nodeKey
      this.fishboneDetailNode = payload
      if (payload.type === 'root') {
        this.fishboneDetailRequestToken++
        this.fishboneTaskRow = {}
        this.fishboneTaskAttachments = []
        this.fishboneLogList = []
        this.loadFishboneRootAttachments()
        this.fishboneDetailVisible = true
        return
      }
      this.loadFishboneTaskDetail(payload)
    },
    /**
     * 加载根节点汇总附件。
     */
    loadFishboneRootAttachments: function () {
      return this.loadOrderRootAttachments().then(function (rows) {
        this.fishboneRootAttachments = rows
        return rows
      }.bind(this))
    },
    /**
     * 加载任务节点维护记录、跟进日志和附件。
     */
    loadFishboneTaskDetail: function (node) {
      if (!node || !node.idseq || !node.lstseq) {
        this.showPrompt(this.$LANG('1442', '提示') + '：' + this.$LANG('1663', '请输入'))
        return
      }
      var requestToken = ++this.fishboneDetailRequestToken
      var orderRow = Object.assign({}, node.raw || {})
      this.fishboneTaskRow = orderRow
      this.fishboneDetailVisible = true
      this.refreshOrderProcessDetailRows(orderRow, requestToken).then(function () {
        if (requestToken !== this.fishboneDetailRequestToken) return
        this.fishboneDetailVisible = true
      }.bind(this)).catch(function (error) {
        if (requestToken !== this.fishboneDetailRequestToken) return
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
        this.fishboneDetailVisible = true
      }.bind(this))
    },
    /**
     * 空值展示兜底。
     */
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    /**
     * 主弹窗完全打开后刷新画布尺寸或初始化思维导图。
     */
    handleMainDialogOpened: function () {
      this.mainDialogOpened = true
      this.startContainerResizeObserver()
      if (this.mindMap) this.resizeMindMap()
      else this.scheduleInitMindMap()
    },
    /**
     * 主弹窗关闭时清理详情状态和思维导图实例。
     */
    handleMainDialogClosed: function () {
      this.mainDialogOpened = false
      this.stopContainerResizeObserver()
      this.handleClose()
      this.destroyMindMap()
    },
    /**
     * 兼容旧抽屉命名，供历史引用继续走主弹窗逻辑。
     */
    handleDrawerOpened: function () {
      this.handleMainDialogOpened()
    },
    handleDrawerClosed: function () {
      this.handleMainDialogClosed()
    },
    /**
     * 通知父组件关闭主弹窗。
     */
    closeMainDialog: function () {
      this.innerVisible = false
    },
    closeDrawer: function () {
      this.closeMainDialog()
    },
    /**
     * 放大思维导图视图。
     */
    zoomIn: function () {
      if (this.mindMap && this.mindMap.view && typeof this.mindMap.view.enlarge === 'function') this.mindMap.view.enlarge()
    },
    /**
     * 缩小思维导图视图。
     */
    zoomOut: function () {
      if (this.mindMap && this.mindMap.view && typeof this.mindMap.view.narrow === 'function') this.mindMap.view.narrow()
    },
    /**
     * 将流程图适配到当前容器，并恢复容器可见性。
     */
    fitView: function () {
      if (!this.mindMap || !this.mindMap.view || typeof this.mindMap.view.fit !== 'function') return
      this.cleanupRenderedMindMapArtifacts()
      this.mindMap.view.fit(function () {}, false, 72)
      this.cleanupRenderedMindMapArtifacts()
      this.normalizeRenderedView()
      this.updateSelectedNodeStyle(this.getSelectedNodeData())
      var container = this.$refs.mindMapContainer
      if (container) container.style.visibility = ''
      this.syncHtmlNodeOverlay()
      this.setHtmlNodeOverlayVisibility('')
    },
    /**
     * 给 simple-mind-map 渲染过程加保护，避免折叠/展开时复用的自定义 DOM 重叠。
     */
    bindMindMapRenderGuards: function (mindMap) {
      if (!mindMap || mindMap.__processMindMapRenderGuardBound) return
      var self = this
      if (typeof mindMap.on === 'function') {
        mindMap.on('node_tree_render_end', function () {
          self.cleanupRenderedMindMapArtifacts()
          self.syncHtmlNodeOverlay()
        })
        if (this.useHtmlNodeOverlay) {
          var scheduleOverlaySync = function () {
            self.scheduleHtmlNodeOverlaySync()
          }
          mindMap.on('view_data_change', scheduleOverlaySync)
          mindMap.on('scale', scheduleOverlaySync)
          mindMap.on('translate', scheduleOverlaySync)
        }
        mindMap.on('expand_btn_click', function () {
          self.viewFitTimers.push(setTimeout(function () {
            self.cleanupRenderedMindMapArtifacts()
            self.updateSelectedNodeStyle(self.getSelectedNodeData())
            self.syncHtmlNodeOverlay()
          }, 40))
          self.viewFitTimers.push(setTimeout(function () {
            self.cleanupRenderedMindMapArtifacts()
            self.updateSelectedNodeStyle(self.getSelectedNodeData())
            self.syncHtmlNodeOverlay()
          }, 120))
          self.viewFitTimers.push(setTimeout(function () {
            self.cleanupRenderedMindMapArtifacts()
            self.updateSelectedNodeStyle(self.getSelectedNodeData())
            self.syncHtmlNodeOverlay()
          }, 260))
        })
      }
      mindMap.__processMindMapRenderGuardBound = true
    },
    /**
     * 在节点树渲染完成后执行视图适配，并设置超时兜底。
     */
    scheduleFitView: function () {
      var self = this
      this.clearViewFitTimers()
      var mindMap = this.mindMap
      if (!mindMap) return
      var handled = false
      var runFit = function () {
        if (handled) return
        handled = true
        if (self.viewFitHandler && self.viewFitMindMap && typeof self.viewFitMindMap.off === 'function') {
          self.viewFitMindMap.off('node_tree_render_end', self.viewFitHandler)
        }
        self.viewFitHandler = null
        self.viewFitMindMap = null
        self.viewFitTimers.push(setTimeout(function () {
          if (self.mindMap === mindMap) self.fitView()
        }, 60))
      }
      this.viewFitHandler = runFit
      this.viewFitMindMap = mindMap
      if (typeof mindMap.on === 'function' && typeof mindMap.off === 'function') {
        mindMap.on('node_tree_render_end', runFit)
      } else {
        this.viewFitTimers.push(setTimeout(runFit, 0))
      }
      this.viewFitTimers.push(setTimeout(runFit, 500))
    },
    /**
     * 清理视图适配监听和计时器。
     */
    clearViewFitTimers: function () {
      if (this.viewFitHandler && this.viewFitMindMap && typeof this.viewFitMindMap.off === 'function') {
        this.viewFitMindMap.off('node_tree_render_end', this.viewFitHandler)
      }
      this.viewFitHandler = null
      this.viewFitMindMap = null
      this.viewFitTimers.forEach(function (timer) { clearTimeout(timer) })
      this.viewFitTimers = []
    },
    /**
     * 将已渲染节点整体平移到容器可视区域内。
     */
    normalizeRenderedView: function () {
      if (!this.mindMap || !this.mindMap.view || typeof this.mindMap.view.translateXY !== 'function') return
      var container = this.$refs.mindMapContainer
      if (!container) return
      var canvasRect = container.getBoundingClientRect()
      if (!canvasRect.width || !canvasRect.height) return
      var nodeRect = null
      if (this.useHtmlNodeOverlay) {
        var modelRect = this.getVisibleMindMapModelRect()
        if (!modelRect) return
        var transform = this.getMindMapDrawTransform()
        nodeRect = {
          left: canvasRect.left + modelRect.left * transform.scaleX + transform.translateX,
          right: canvasRect.left + modelRect.right * transform.scaleX + transform.translateX,
          top: canvasRect.top + modelRect.top * transform.scaleY + transform.translateY,
          bottom: canvasRect.top + modelRect.bottom * transform.scaleY + transform.translateY
        }
      } else {
        var nodeList = Array.prototype.slice.call(container.querySelectorAll('.node-card'))
        var rectList = nodeList.map(function (item) {
          return item.getBoundingClientRect()
        }).filter(function (rect) {
          return rect.width > 0 && rect.height > 0 && rect.left > -10000 && rect.top > -10000
        })
        if (!rectList.length) return
        nodeRect = rectList.reduce(function (acc, rect) {
          return {
            left: Math.min(acc.left, rect.left),
            right: Math.max(acc.right, rect.right),
            top: Math.min(acc.top, rect.top),
            bottom: Math.max(acc.bottom, rect.bottom)
          }
        }, { left: Infinity, right: -Infinity, top: Infinity, bottom: -Infinity })
      }
      var padding = 48
      var availableHeight = canvasRect.height - padding * 2
      var nodeHeight = nodeRect.bottom - nodeRect.top
      var targetLeft = canvasRect.left + padding
      var targetTop = nodeHeight <= availableHeight ? canvasRect.top + (canvasRect.height - nodeHeight) / 2 : canvasRect.top + padding
      var deltaX = targetLeft - nodeRect.left
      var deltaY = targetTop - nodeRect.top
      if (Math.abs(deltaX) > 1 || Math.abs(deltaY) > 1) this.mindMap.view.translateXY(deltaX, deltaY)
    },
    /**
     * 清理 simple-mind-map 在折叠/展开后可能遗留的自定义节点渲染物。
     */
    cleanupRenderedMindMapArtifacts: function () {
      if (this.mindMap && this.mindMap.renderer && this.mindMap.renderer.isRendering) return
      this.cleanupCollapsedChildNodes()
      this.cleanupDuplicateNodeCards()
      this.rebuildVisibleMindMapLines()
      this.repairMissingNodeCards()
      this.cleanupDuplicateNodeCards()
      this.rebuildVisibleMindMapLines()
    },
    /**
     * 父节点折叠后，强制移除其子节点的旧 SVG 组，避免收起后残留在画布上。
     */
    cleanupCollapsedChildNodes: function () {
      var root = this.mindMap && this.mindMap.renderer && this.mindMap.renderer.root
      if (!root) return
      var removeLines = function (node) {
        if (!node) return
        if (typeof node.removeLine === 'function') {
          node.removeLine()
          return
        }
        if (node._lines && node._lines.length) {
          node._lines.forEach(function (line) {
            if (line && typeof line.remove === 'function') line.remove()
          })
          node._lines = []
        }
      }
      var hideNodeRenderArtifacts = function (node) {
        if (!node) return
        removeLines(node)
        if (node.group && typeof node.group.hide === 'function') node.group.hide()
        if (node.children && node.children.length) node.children.forEach(hideNodeRenderArtifacts)
      }
      var walk = function (node) {
        if (!node || !node.children || !node.children.length) return
        if (typeof node.getData === 'function' && node.getData('expand') === false) {
          removeLines(node)
          node.children.forEach(hideNodeRenderArtifacts)
          return
        }
        node.children.forEach(walk)
      }
      walk(root)
    },
    /**
     * 当前节点组存在但 custom foreignObject 丢失时，重新渲染该节点内容。
     */
    repairMissingNodeCards: function () {
      var root = this.mindMap && this.mindMap.renderer && this.mindMap.renderer.root
      if (!root) return
      var isNodeVisible = function (node) {
        var parent = node && node.parent
        while (parent) {
          if (parent.getData && parent.getData('expand') === false) return false
          parent = parent.parent
        }
        return true
      }
      var repairNode = function (node) {
        if (!node || !node.group) return
        if (!isNodeVisible(node)) return
        if (node.nodeDraw && typeof node.nodeDraw.has === 'function' && !node.nodeDraw.has(node.group)) {
          node.nodeDraw.add(node.group)
        }
        if (!node.group.node) return
        if (node.group.show && node.parent && node.parent.getData && node.parent.getData('expand') !== false) node.group.show()
        if (node.group.node.querySelector && node.group.node.querySelector('.node-card')) return
        if (typeof node.reRender === 'function') {
          node.reRender(['custom'])
        } else if (typeof node.layout === 'function' && typeof node.update === 'function') {
          node.layout()
          node.update()
        }
      }
      var walk = function (node) {
        if (!node) return
        repairNode(node)
        if (node.children && node.children.length && (!node.getData || node.getData('expand') !== false)) {
          node.children.forEach(walk)
        }
      }
      walk(root)
    },
    /**
     * simple-mind-map 折叠/展开会复用节点实例，自定义 foreignObject 偶发重复挂载。
     * 使用“ORDNO + IDSEQ”业务 key 去重，避免内部 uid 变化后漏清旧 DOM。
     */
    cleanupDuplicateNodeCards: function () {
      var container = this.$refs.mindMapContainer
      if (!container) return
      var self = this
      var getCardGroup = function (card) {
        return self.getNodeCardRenderGroup(card, container)
      }
      var getRenderedCards = function (selector) {
        return Array.prototype.slice.call(container.querySelectorAll(selector || '.node-card')).filter(function (card) {
          if (!getCardGroup(card)) return false
          var rect = card.getBoundingClientRect()
          return rect.width > 0 && rect.height > 0
        })
      }
      var sortByRenderSeq = function (a, b) {
        var aSeq = Number(a.getAttribute('data-node-render-seq')) || 0
        var bSeq = Number(b.getAttribute('data-node-render-seq')) || 0
        return aSeq - bSeq
      }
      var removeCard = function (card) {
        var foreignObject = card.closest ? card.closest('foreignObject') : null
        if (foreignObject && foreignObject.parentNode) {
          foreignObject.parentNode.removeChild(foreignObject)
        } else if (card.parentNode) {
          card.parentNode.removeChild(card)
        }
      }
      var removeGroupOrCard = function (card) {
        var group = getCardGroup(card)
        if (group && group.parentNode) {
          group.parentNode.removeChild(group)
          return
        }
        removeCard(card)
      }
      var removeOlderCards = function (cards) {
        if (cards.length <= 1) return
        cards.sort(sortByRenderSeq)
        cards.slice(0, -1).forEach(removeCard)
      }
      var currentGroupsByBusinessKey = {}
      var collectCurrentGroupsByBusinessKey = function (node) {
        if (!node) return
        var data = node.nodeData && node.nodeData.data
        var businessKey = self.getRenderedNodeBusinessKey(data)
        if (businessKey && node.group && node.group.node) currentGroupsByBusinessKey[businessKey] = node.group.node
        if (node.children && node.children.length && (!node.getData || node.getData('expand') !== false)) {
          node.children.forEach(collectCurrentGroupsByBusinessKey)
        }
      }
      collectCurrentGroupsByBusinessKey(this.mindMap && this.mindMap.renderer && this.mindMap.renderer.root)
      var cardsByBusinessKey = {}
      getRenderedCards('.node-card[data-node-business-key]').forEach(function (card) {
        var businessKey = card.getAttribute('data-node-business-key')
        if (!businessKey) return
        if (!cardsByBusinessKey[businessKey]) cardsByBusinessKey[businessKey] = []
        cardsByBusinessKey[businessKey].push(card)
      })
      Object.keys(cardsByBusinessKey).forEach(function (businessKey) {
        var currentGroup = currentGroupsByBusinessKey[businessKey]
        if (!currentGroup) {
          cardsByBusinessKey[businessKey].forEach(removeGroupOrCard)
          return
        }
        var currentCards = []
        cardsByBusinessKey[businessKey].forEach(function (card) {
          var group = getCardGroup(card)
          if (group && group !== currentGroup) {
            removeGroupOrCard(card)
            return
          }
          currentCards.push(card)
        })
        removeOlderCards(currentCards)
      })
      var cardsByGroup = []
      getRenderedCards('.node-card').forEach(function (card) {
        var group = getCardGroup(card)
        if (!group) return
        var item = cardsByGroup.filter(function (row) { return row.group === group })[0]
        if (!item) {
          item = { group: group, cards: [] }
          cardsByGroup.push(item)
        }
        item.cards.push(card)
      })
      cardsByGroup.forEach(function (item) {
        removeOlderCards(item.cards)
      })
    },
    /**
     * 从自定义节点卡片反查 simple-mind-map 的 SVG 节点组。
     */
    getNodeCardRenderGroup: function (card, stopNode) {
      if (!card) return null
      if (card.closest) {
        var closestGroup = card.closest('.smm-node')
        if (closestGroup) return closestGroup
      }
      var node = card.parentNode
      while (node && node !== stopNode) {
        if (node.getAttribute) {
          var className = node.getAttribute('class') || ''
          if (String(className).split(/\s+/).indexOf('smm-node') > -1) return node
        }
        node = node.parentNode
      }
      return null
    },
    /**
     * 根据当前展开状态重建连线层，避免折叠后旧 path 留成空树枝。
     */
    rebuildVisibleMindMapLines: function () {
      var mindMap = this.mindMap
      var root = mindMap && mindMap.renderer && mindMap.renderer.root
      var lineDraw = mindMap && mindMap.lineDraw
      if (!root || !lineDraw || typeof root.renderLine !== 'function') return
      if (mindMap.renderer && mindMap.renderer.isRendering) return
      var resetNodeLines = function (node) {
        if (!node) return
        if (node._lines && node._lines.length) {
          node._lines.forEach(function (line) {
            if (line && typeof line.remove === 'function') line.remove()
          })
        }
        node._lines = []
        if (node.children && node.children.length) node.children.forEach(resetNodeLines)
      }
      resetNodeLines(root)
      if (typeof lineDraw.clear === 'function') lineDraw.clear()
      root.renderLine(true)
    },
    /**
     * 读取画布容器真实尺寸，simple-mind-map 的 reset/fit 依赖这个尺寸。
     */
    getMindMapContainerSize: function () {
      var container = this.$refs.mindMapContainer
      if (!container) return { width: 0, height: 0 }
      var rect = container.getBoundingClientRect()
      return {
        width: Math.round(rect.width || 0),
        height: Math.round(rect.height || 0)
      }
    },
    /**
     * 弹窗或浏览器尺寸变化时，通知 simple-mind-map 重新读取容器宽高。
     */
    startContainerResizeObserver: function () {
      var container = this.$refs.mindMapContainer
      if (!container) return
      if (typeof ResizeObserver === 'undefined') {
        this.scheduleResize()
        return
      }
      if (this.resizeObserver) return
      var self = this
      this.lastContainerSize = this.getMindMapContainerSize()
      this.resizeObserver = new ResizeObserver(function () {
        var nextSize = self.getMindMapContainerSize()
        if (!nextSize.width || !nextSize.height) return
        if (nextSize.width === self.lastContainerSize.width && nextSize.height === self.lastContainerSize.height) return
        self.lastContainerSize = nextSize
        self.scheduleResize()
      })
      var observedTargets = []
      var observeTarget = function (target) {
        if (!target || observedTargets.indexOf(target) > -1) return
        self.resizeObserver.observe(target)
        observedTargets.push(target)
      }
      observeTarget(container)
      observeTarget(this.$refs.container)
      observeTarget(container.closest ? container.closest('.fishbone-dialog-shell') : null)
    },
    /**
     * 断开容器尺寸监听并清理 resize 防抖。
     */
    stopContainerResizeObserver: function () {
      if (this.resizeObserver && typeof this.resizeObserver.disconnect === 'function') this.resizeObserver.disconnect()
      this.resizeObserver = null
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = null
      }
      this.lastContainerSize = { width: 0, height: 0 }
    },
    /**
     * 刷新思维导图尺寸并重新适配视图。
     */
    resizeMindMap: function () {
      if (!this.mindMap) return
      try {
        var nextSize = this.getMindMapContainerSize()
        if (!nextSize.width || !nextSize.height) return
        this.lastContainerSize = nextSize
        if (typeof this.mindMap.resize === 'function') this.mindMap.resize()
        this.scheduleFitView()
        this.scheduleHtmlNodeOverlaySync()
      } catch (e) {
        console.warn('刷新思维导图尺寸失败:', e)
      }
    },
    /**
     * 延迟执行尺寸刷新，等待 DOM 布局稳定。
     */
    scheduleResize: function () {
      var self = this
      if (this._isBeingDestroyed || this._isDestroyed) return
      if (this.resizeTimer) clearTimeout(this.resizeTimer)
      this.$nextTick(function () {
        if (self._isBeingDestroyed || self._isDestroyed) return
        if (self.resizeTimer) clearTimeout(self.resizeTimer)
        self.resizeTimer = setTimeout(function () {
          if (self._isBeingDestroyed || self._isDestroyed) return
          self.resizeTimer = null
          self.resizeMindMap()
        }, 80)
      })
    },
    /**
     * 重置视图缩放和平移后重新适配。
     */
    resetView: function () {
      if (!this.mindMap || !this.mindMap.view) return
      if (typeof this.mindMap.resize === 'function') {
        var nextSize = this.getMindMapContainerSize()
        if (!nextSize.width || !nextSize.height) return
        this.lastContainerSize = nextSize
        this.mindMap.resize()
      }
      if (typeof this.mindMap.view.reset === 'function') this.mindMap.view.reset()
      this.scheduleFitView()
      this.scheduleHtmlNodeOverlaySync()
    },
    /**
     * 折叠或展开详情侧栏，并触发画布重算。
     */
    toggleDetailPanel: function () {
      if (this.isDetailPanelCollapsed) {
        this.detailPanelCollapsed = false
        this.detailPanelLockedCollapsed = false
      } else {
        this.detailPanelCollapsed = true
        this.detailPanelLockedCollapsed = true
      }
      this.scheduleResize()
    },
    /**
     * 关闭详情侧栏并清理选中节点、来源单据弹窗和请求令牌。
     */
    handleClose: function () {
      this.selectedNode = null
      this.selectedNodeKey = ''
      this.updateSelectedNodeStyle(null)
      this.fishboneDetailRequestToken++
      this.fishboneDetailVisible = false
      this.fishboneDetailNode = null
      this.detailPanelCollapsed = false
      this.detailPanelLockedCollapsed = false
      this.closeSourceDialogs()
    },
    /**
     * 打开或下载附件，PDF 走在线预览，其它文件直接下载。
     */
    fishboneOpenAttachment: function (item) {
      if (!item || !item.FILEPATH) return
      var filePath = item.FILEPATH
      if (String(filePath).toLowerCase().lastIndexOf('.pdf') > -1) {
        var routeUrl = this.$router.resolve({
          path: '/fullPreview',
          query: { fileUrl: filePath }
        })
        window.open(routeUrl.href, '_blank')
        return
      }
      var arrName = String(filePath).split('/')
      FileSaver.saveAs(filePath, arrName[arrName.length - 1])
    },
    /**
     * 新增任务跟进记录，必要时先补齐负责人和截止日期。
     */
    fishboneLogAdd: function () {
      if (this.isReadonlyMode) return
      if (!this.currentDetailNode || this.currentDetailNode.type === 'root') {
        this.showPrompt(this.$LANG('1517', '根节点下不能操作'))
        return
      }
      var row = this.currentTaskRow || {}
      if (!this.canMaintainOrderProcessRow(row)) {
        this.showPrompt(this.$LANG('1926', '当前任务的负责人与当前账号不匹配，不能操作'))
        return
      }
      if (!this.getOrderProcessOwner(row) || !this.getOrderProcessFindDate(row)) {
        this.fishboneTaskProgressEdit()
        return
      }
      this.logRow = {
        DTTM: getDate('day'),
        STFG: row.STFG || '进行中',
        PCT: row.PCT !== undefined && row.PCT !== null && row.PCT !== '' ? Number(row.PCT) : 0,
        IDSEQ: row.IDSEQ,
        LSTSEQ: '',
        REFLSTSEQ: row.LSTSEQ,
        LOGRMK: '',
        LOGMODE: 'ADD'
      }
      this.phoData = []
      this.delLogImg = []
      this.logWin = true
    },
    /**
     * 编辑已有跟进记录，并加载该记录附件。
     */
    fishboneLogEdit: function (item) {
      if (this.isReadonlyMode) return
      this.logRow = Object.assign({}, this.cloneValue(item), { PHODATA: '', LOGMODE: 'EDIT' })
      this.phoData = []
      this.delLogImg = []
      this.loadOrderProcessLogAttachments(this.currentTaskRow || {}, item).then(function (rows) {
        this.phoData = rows
      }.bind(this)).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.logWin = true
      }.bind(this))
    },
    /**
     * 打开任务进度、状态、负责人和截止日期维护弹窗。
     */
    fishboneTaskProgressEdit: function () {
      if (this.isReadonlyMode) return
      if (!this.currentDetailNode || this.currentDetailNode.type === 'root') {
        this.showPrompt(this.$LANG('1517', '根节点下不能操作'))
        return
      }
      var row = this.currentTaskRow || {}
      if (!this.canMaintainOrderProcessRow(row)) {
        this.showPrompt(this.$LANG('1926', '当前任务的负责人与当前账号不匹配，不能操作'))
        return
      }
      this.pctMode = 'TASK'
      this.vPct = row.PCT !== undefined && row.PCT !== null && row.PCT !== '' ? Number(row.PCT) : 0
      this.tStfg = row.STFG || ''
      this.tRmk = row.RMK || ''
      this.processOwner = this.getOrderProcessOwner(row)
      this.processFindDttm = this.getOrderProcessFindDate(row)
      this.processOwnerEmpId = ''
      this.pctWin = true
    },
    /**
     * 兼容详情面板“新增跟进”入口。
     */
    fishboneFollowAdd: function () {
      this.fishboneLogAdd()
    },
    /**
     * 将字段键值对拼接为 updateRec 接口使用的 set 语句。
     */
    buildUpdateCond: function (pairs) {
      return ' set ' + pairs.map(function (item) {
        if (typeof item.value === 'number') return item.key + '=' + item.value
        return item.key + "='" + String(item.value || '').replace(/'/g, "''") + "'"
      }).join(',')
    },
    /**
     * 保存任务进度维护信息到 ORD_PROCESS 并刷新节点展示。
     */
    fishbonePctSave: function () {
      if (this.isReadonlyMode) return
      if (this.vPct === undefined || this.vPct === null || this.vPct === '' || !this.tStfg) {
        this.showPrompt(this.$LANG('0685', '完成进度') + this.$LANG('1650', '或') + this.$LANG('0568', '任务状态') + this.$LANG('2051', '不能为空'))
        return
      }
      var orderRow = this.currentTaskRow || {}
      if (!this.processOwner) {
        this.showPrompt(this.$LANG('', '负责人') + this.$LANG('2051', '不能为空'))
        return
      }
      if (!this.processFindDttm) {
        this.showPrompt(this.$LANG('', '截止时间') + this.$LANG('2051', '不能为空'))
        return
      }
      this.saveOrderProcessRow(orderRow, {
        PCT: Number(this.vPct),
        STFG: this.tStfg,
        RMK: this.tRmk || '',
        EMPNM: this.processOwner,
        FINDTTM: this.processFindDttm
      }).then(function (savedRow) {
        this.pctWin = false
        this.clearSourceStatusForRow(orderRow)
        this.fishboneTaskRow = this.normalizeOrderProcessSavedRow(orderRow, savedRow)
        this.replaceWorkDetailRow(this.fishboneTaskRow)
        this.scheduleInitMindMap()
        this.scheduleSourceStatusProbe(this.internalWorkDetails)
      }.bind(this)).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this))
    },
    /**
     * 校验跟进记录必填项。
     */
    validateFishboneLog: function () {
      var valid = true
      this.logNull.some(function (item) {
        if (!this.logRow[item.FLDNO]) {
          valid = false
          this.showPrompt(this.$translate.getColTitle(item, this.$store.state.lang) + this.$LANG('2051', '不能为空'))
          return true
        }
        return false
      }.bind(this))
      return valid
    },
    /**
     * 判断附件是否已经保存到后端，避免重复写入。
     */
    isPersistedAttachment: function (item) {
      return !!(item && ((item.IDSEQ && item.LSTSEQ) || item.__PROCESS_MIND_MAP_SAVED))
    },
    /**
     * 保存新增附件并删除用户标记移除的附件。
     */
    saveFishboneLogAttachments: function (ownerId, logId) {
      if (!ownerId || !logId) return Promise.resolve()
      var saveList = (this.phoData || []).filter(function (item) {
        return !this.isPersistedAttachment(item)
      }.bind(this))
      var saveChain = Promise.all(saveList.map(function (item) {
        var payload = Object.assign({}, item, {
          IDSEQ: ownerId,
          REFLSTSEQ: logId,
          FILETY: item.FILETY || 'IMG'
        })
        return this.$axios({
          method: 'post',
          url: this.authUrl('xuper_auth/tableBodySave'),
          data: { p_json: JSON.stringify(payload), p_table: 'mat_img', p_idseq: ownerId }
        }).then(function (res) {
          if (res && res.code !== '200') throw new Error(res.result || res.message || this.$LANG('1442', '提示'))
          this.$set(item, '__PROCESS_MIND_MAP_SAVED', true)
          return res
        }.bind(this))
      }.bind(this)))
      return saveChain.then(function () {
        return Promise.all((this.delLogImg || []).map(function (item) {
          return this.deleteFishboneImageRecord(item)
        }.bind(this)))
      }.bind(this))
    },
    /**
     * 保存新增或编辑的跟进记录，并刷新详情、节点和来源单据探测状态。
     */
    fishboneLogSave: function () {
      if (this.isReadonlyMode) return
      if (!this.validateFishboneLog()) return
      var row = this.currentTaskRow || {}
      var isEdit = this.logRow.LOGMODE === 'EDIT'
      var targetRow = isEdit ? Object.assign({}, row, this.logRow) : row
      var logPct = this.logRow.PCT !== undefined && this.logRow.PCT !== null && this.logRow.PCT !== '' ? Number(this.logRow.PCT) : (targetRow.PCT || row.PCT || 0)
      var processOwner = this.getOrderProcessOwner(targetRow) || this.getOrderProcessOwner(row)
      var processFindDate = this.getOrderProcessFindDate(targetRow) || this.getOrderProcessFindDate(row)
      if (!this.logRow.STFG) {
        this.showPrompt(this.$LANG('0568', '任务状态') + this.$LANG('2051', '不能为空'))
        return
      }
      if (!processOwner || !processFindDate) {
        this.showPrompt(this.$LANG('', '负责人') + this.$LANG('1650', '或') + this.$LANG('', '截止时间') + this.$LANG('2051', '不能为空'))
        return
      }
      this.saveOrderProcessRow(row, {
        FORCE_INSERT: !isEdit,
        IDSEQ: isEdit ? this.logRow.IDSEQ : '',
        RMK: this.logRow.LOGRMK || '',
        STFG: this.logRow.STFG || targetRow.STFG || row.STFG || '进行中',
        PCT: isNaN(logPct) ? 0 : logPct,
        EMPNM: processOwner,
        FINDTTM: processFindDate
      }).then(function (savedRow) {
        var logId = savedRow.IDSEQ || this.logRow.IDSEQ
        if (logId) {
          this.$set(this.logRow, 'IDSEQ', logId)
          this.$set(this.logRow, 'LOGMODE', 'EDIT')
        }
        return this.saveFishboneLogAttachments(this.getOrderProcessAttachmentOwnerId(row), logId).then(function () {
          return savedRow
        })
      }.bind(this)).then(function (savedRow) {
        this.logWin = false
        this.phoData = []
        this.delLogImg = []
        this.clearSourceStatusForRow(row)
        this.fishboneTaskRow = this.normalizeOrderProcessSavedRow(row, savedRow)
        this.replaceWorkDetailRow(this.fishboneTaskRow)
        return this.refreshOrderProcessDetailRows(row, null, savedRow)
      }.bind(this)).then(function () {
        if (this.currentDetailNode && this.currentDetailNode.type === 'root') this.loadFishboneRootAttachments()
        this.replaceWorkDetailRow(this.fishboneTaskRow)
        this.scheduleInitMindMap()
        this.scheduleSourceStatusProbe(this.internalWorkDetails)
      }.bind(this)).catch(function (error) {
        this.showPrompt((error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this))
    },
    /**
     * 删除跟进记录，并刷新当前任务详情和节点状态。
     */
    fishboneDeleteLog: function (row, index) {
      if (this.isReadonlyMode) return
      this.$confirm(this.$LANG('1564', '你确定要') + this.$LANG('0131', '删除') + this.$LANG('1566', '此行记录吗'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        type: 'info'
      }).then(function () {
        this.$axios({
          method: 'post',
          url: this.authUrl('xuper_auth/delTabRec'),
          data: { p_key: 'idseq', p_value: row.IDSEQ, p_table: 'ORD_PROCESS' }
        }).then(function (res) {
          if (res.code === '200') {
            this.fishboneLogList.splice(index, 1)
            var currentRow = this.currentTaskRow || {}
            this.clearSourceStatusForRow(currentRow)
            this.refreshOrderProcessDetailRows(currentRow).then(function () {
              if (this.currentDetailNode && this.currentDetailNode.type === 'root') this.loadFishboneRootAttachments()
              this.replaceWorkDetailRow(this.fishboneTaskRow)
              this.scheduleInitMindMap()
              this.scheduleSourceStatusProbe(this.internalWorkDetails)
            }.bind(this))
          } else {
            this.showPrompt(res.result)
          }
        }.bind(this))
      }.bind(this)).catch(function () {})
    },
    /**
     * 上传前准备 OSS 上传参数。
     */
    fishboneBeforeUpload: function () {
      this.uploadData = {
        code: this.vUsername + getDate('year'),
        p_type: 'IMG',
        p_path: '/web/web_images/material/',
        p_user: this.vUsername
      }
      return new Promise(function (resolve) {
        this.$nextTick(function () { resolve(true) })
      }.bind(this))
    },
    /**
     * 上传成功后把附件加入当前跟进附件列表。
     */
    fishboneUploadSuccess: function (res, file) {
      this.videoUploadPercent = 0
      this.videoFlag = false
      if (res.code === '200') {
        this.phoData.push({ FILEPATH: this.$store.state.nasUrl + res.result, FILENM: file.name, FILETY: 'IMG', PATH: '/web/web_images/material/' + res.result, HASHVAL: res.hashvalue })
      } else if (res.code === '201') {
        this.phoData.push({ FILEPATH: res.filepath, FILENM: file.name, FILETY: 'IMG', PATH: '', REFIDSEQ: res.idseq, REFLSTSEQ: res.lstseq })
      } else {
        this.showPrompt(res.result)
      }
    },
    /**
     * 同步上传进度到进度条。
     */
    fishboneUploadProgress: function (event) {
      this.videoFlag = true
      this.videoUploadPercent = Math.floor(event.percent)
    },
    /**
     * 上传文件超过限制时给出提示。
     */
    fishboneHandleMaxSize: function (file) {
      this.showPrompt(file.name + this.$LANG('1561', ' 文件太大, 不能超出') + '10M')
    },
    /**
     * 从当前跟进附件列表移除附件，并记录待删除项。
     */
    fishboneDeleteAttachment: function (item, index) {
      this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(function () {
        this.delLogImg.push({ IDSEQ: item.IDSEQ, LSTSEQ: item.LSTSEQ, FILEPATH: item.FILEPATH, PATH: item.PATH })
        this.phoData.splice(index, 1)
      }.bind(this)).catch(function () {})
    },
    /**
     * 删除附件表记录，外部 OSS 文件存在时同步删除实体文件。
     */
    deleteFishboneImageRecord: function (item) {
      var filePath = item.FILEPATH
      var path = item.PATH
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/delTabRec'),
        data: { p_key: 'idseq', p_value: item.IDSEQ, p_key2: 'lstseq', p_value2: item.LSTSEQ, p_key5: 'filepath', p_value5: item.FILEPATH, p_table: 'mat_img' }
      }).then(function (res) {
        if (res.code !== '200') {
          throw new Error(res.message || res.result || this.$LANG('1442', '提示'))
        }
        if (String(filePath).indexOf('https://') > -1 && filePath && path) {
          return this.$axios({
            method: 'post',
            url: this.authUrl( '/xuper_oss/ftpDelete'),
            data: { p_path: '/volume1' + path }
          })
        }
      }.bind(this))
    },
    /**
     * 用保存后的维护数据替换内存中的任务节点行。
     */
    replaceWorkDetailRow: function (row) {
      if (!row || !row.CODE) return
      var nextRow = Object.assign({}, row)
      if (nextRow.PCT !== undefined && nextRow.PCT !== null && nextRow.PCT !== '') nextRow.progress = Number(nextRow.PCT) || 0
      this.internalWorkDetails = this.internalWorkDetails.map(function (item) {
        if (item.CODE === nextRow.CODE || (item.IDSEQ === nextRow.IDSEQ && item.LSTSEQ === nextRow.LSTSEQ)) {
          return Object.assign({}, item, nextRow)
        }
        return item
      })
    },
    /**
     * 清理 simple-mind-map 内部渲染计时器，避免销毁后异步回调报错。
     */
    clearMindMapInnerTimers: function (mindMap) {
      if (!mindMap || !mindMap.renderer) return
      if (mindMap.renderer.renderTimer) {
        clearTimeout(mindMap.renderer.renderTimer)
        mindMap.renderer.renderTimer = null
      }
      if (mindMap.renderer.emitNodeActiveEventTimer) {
        clearTimeout(mindMap.renderer.emitNodeActiveEventTimer)
        mindMap.renderer.emitNodeActiveEventTimer = null
      }
    },
    /**
     * 销毁思维导图实例并清理所有相关计时器。
     */
    destroyMindMap: function () {
      this.mindMapRenderToken += 1
      this.stopContainerResizeObserver()
      if (this.initMindMapTimer) {
        clearTimeout(this.initMindMapTimer)
        this.initMindMapTimer = null
      }
      this.clearViewFitTimers()
      this.cancelHtmlNodeOverlaySync()
      this.clearHtmlNodeOverlay()
      try {
        if (this.mindMap) {
          this.clearMindMapInnerTimers(this.mindMap)
          if (this.mindMap.destroy) this.mindMap.destroy()
        }
      } catch (e) {
        console.warn('销毁思维导图实例失败:', e)
      }
      this.mindMap = null
    }
  }
}

/**
 * 根节点详情侧栏标题兜底。
 */
function displayRootTitle(row) {
  row = row || {}
  return row.TASKNM || row.WKNM || '订单详情'
}
